document.addEventListener('DOMContentLoaded',function(){
    darkMode();
    seePasswordLogin();
    switchPanels();
    showNominaColumns();
    listenImportMembersButtom();
    showMemberForms();
    showMemberDetailModal();
    listenNominaAttendanceChecks();
    listenQuickNominaSearch();
    listenOrgScanModal();
    showRamasActions();
    createMemberByForm();
    editMemberByForm();
    deleteMemberByForm();
    tableSearchMembers();
    loaderMembersForm();
    createRamaInTable();
    editRamaInTable();
    deleteRamaInTable();
    createSignerInTable();
    sortMembersList();
    initNominaTitleMarquee();
    addRamaSettingForm();
    saveNominaPreference();
    manageNominaRequirementsConfig();
    listenNominaList();
    listenNominaEstadoFilter();
    manageNominaFinalizeAction();
    listenGeneralSettings();
    listenExcelImportMapper();
})

function initNominaTitleMarquee(){
    const updateMainNominaTitle = () => {
        const titleBox = document.querySelector('.cont_botones .info_nomina .nombre_nomina');
        if(!titleBox){return;}

        const viewport = titleBox.querySelector('.nomina_title_viewport');
        const text = titleBox.querySelector('.nomina_title_text');
        if(!viewport || !text){return;}

        titleBox.classList.toggle('scrollable',text.scrollWidth > viewport.clientWidth);
    };

    const updateNominaCardTitles = () => {
        const cardTitles = document.querySelectorAll('.panel_nomina .nombre_left input');
        cardTitles.forEach((title) => {
            const viewport = title.closest('.nombre_left');
            if(!viewport){return;}

            viewport.classList.remove('scrollable');
            viewport.style.removeProperty('--nomina-title-distance');
            title.style.removeProperty('width');
            title.classList.add('nomina_card_title');

            if(!title.readOnly || viewport.classList.contains('editing')){return;}

            const distance = title.scrollWidth - viewport.clientWidth;
            if(distance > 4){
                viewport.classList.add('scrollable');
                viewport.style.setProperty('--nomina-title-distance', `${distance}px`);
                title.style.width = `${title.scrollWidth}px`;
            }
        });
    };

    const updateTitleOverflow = () => {
        updateMainNominaTitle();
        updateNominaCardTitles();
    };

    updateTitleOverflow();
    if(!initNominaTitleMarquee.resizeBound){
        window.addEventListener('resize',() => initNominaTitleMarquee());
        initNominaTitleMarquee.resizeBound = true;
    }
}

function seePasswordLogin(){
    const eye = document.querySelector('#seePassLogin');
    if(eye){
        const passWord = document.querySelector('.login__input.password');

        //console.log(passWord)
        eye.addEventListener('click',()=>{
            const typeNew = passWord.getAttribute('type') === 'password' ? 'text' : 'password';
            //console.log(typeNew)
            passWord.setAttribute('type', typeNew);

            if(eye.classList.contains('fa-eye-slash')){
                eye.classList.add('fa-eye');
                eye.classList.remove('fa-eye-slash');
            }else{
                eye.classList.remove('fa-eye');
                eye.classList.add('fa-eye-slash');
            }
        })
    }

}

function darkMode(){

    const botonDarkMode = document.querySelectorAll('.dark_mode_boton');
    if(botonDarkMode.length > 0){

        
        const prefiereDark = window.matchMedia('(prefers-color-scheme:dark)');

        prefiereDark.addEventListener('change',function(){
            
        if(prefiereDark.matches){

            document.body.classList.add('dark_mode');
            localStorage.setItem('modo-oscuro','true');
        }
        else{
            document.body.classList.remove('dark_mode');
            localStorage.setItem('modo-oscuro','false');
        }
    })
    
    botonDarkMode.forEach(boton =>{

        boton.addEventListener('click', function(){
    
            document.body.classList.add('dark');
            
            if (document.body.classList.contains('dark_mode')) {
                document.body.classList.remove('dark_mode');
                
            } else {
                document.body.classList.add('dark_mode'); 
            }
            
            setTimeout(() =>{
                document.body.classList.remove('dark');
            },1000)
            
            //Para que el modo elegido se quede guardado en local-storage
            if (document.body.classList.contains('dark_mode')) {
                
                localStorage.setItem('modo-oscuro','true');
            } else {
                
                localStorage.setItem('modo-oscuro','false');
            }
        });
    })
    
    
    //Obtenemos el modo del color actual
    if (localStorage.getItem('modo-oscuro') === 'true') {
        
        document.body.classList.add('dark_mode');
    } else {

        document.body.classList.remove('dark_mode');
    }
}
}

function generateSubPanels() {
    const panelActivo = localStorage.getItem('panelAcredActivo') || 'config';

    const botones = [
        { id: 'nomina', icono: 'fa-user-group', texto: 'Nómina' },
        { id: 'config', icono: 'fa-gears', texto: 'Ajustes' }
    ];

    const contenedor = document.querySelector('.botones_selec');
    if (contenedor) {
        contenedor.innerHTML = ''; // Limpiar por si ya había algo

        botones.forEach(boton => {
            const div = document.createElement('div');
            div.id = boton.id;
            div.className = `opciones${boton.id === panelActivo ? ' activado' : ''}`;

            div.innerHTML = `
                <i class="fa-solid ${boton.icono}" style="color:#4d4d4d;"></i>
                <p>${boton.texto}</p>
            `;

            contenedor.appendChild(div);
        });
    }
}

function switchPanels() {
    const cont_botones = document.querySelector('.cont_botones');
    const cont_paneles = document.querySelector('.paneles_acred');

    if (cont_botones && cont_paneles) {
        const opcionesConfig = cont_botones.querySelectorAll('.opciones');

        opcionesConfig.forEach(opcion => {
            opcion.addEventListener('click', function () {
                const panelName = opcion.id;
                const panel = cont_paneles.querySelector("#" + panelName);

                makePanelsInvisible();
                activeButtom();

                if (panel){
                    panel.style.display = 'block';
                }
                opcion.classList.add('activado');

                // Guardar el subpanel activo
                // console.log(panelName)
                localStorage.setItem('panelAcredActivo', panelName);
            });
        });

        function makePanelsInvisible() {
            const paneles = cont_paneles.querySelectorAll(".panel_acred");
            paneles.forEach(panel => {
                panel.style.display = 'none';
            });
        }

        function activeButtom() {
            opcionesConfig.forEach(opcion => {
                opcion.classList.remove('activado');
            });
        }
    }
}

async function showNominaColumns(){
    if(typeof nominaNr === 'undefined'){
        return;
    }

    const nomPreference = await getNominaPreference();
    setNominaPreferenceChecks(nomPreference);
    applyNominaColumnPreferences(nominaPreferenceToChecks(nomPreference));

}

async function getNominaPreference(){
    if(typeof nominaNr === 'undefined'){
        return {};
    }

    const campos = {'NominaNr':nominaNr}
    try {
        const response = await fetch('/api/getNominaPreference.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(campos)
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Unidades');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function nominaPreferenceToChecks(preferences){
    return {
        check_dni: Number(preferences.ShowDocument ?? 1),
        check_org: Number(preferences.ShowOrganismo ?? 1),
        check_rama: Number(preferences.ShowRama ?? 1),
        check_req_event: Number(preferences.ShowReqEvent ?? 1),
        check_req_fijos: Number(preferences.ShowReqFijos ?? 1)
    };
}

function setNominaPreferenceChecks(preferences){
    const checks = nominaPreferenceToChecks(preferences);

    Object.entries(checks).forEach(([id, value]) => {
        const input = document.getElementById(id);
        if(input){
            input.checked = value === 1;
        }
    });
}

function getNominaPreferenceFormData(inputsCheck){
    const values = {};

    inputsCheck.forEach((input) => {
        values[input.id] = input.checked ? 1 : 0;
    });

    return values;
}

function applyNominaColumnPreferences(preferences){
    const rows = document.querySelectorAll('.lista_miembros .row_miembro');
    if(rows.length === 0){
        return;
    }

    const columns = [
        {key: 'asistencia', selector: '.campo_asistencia', width: '.25fr', visible: true},
        {key: 'nombre', selector: '.campo_nombre', width: '1fr', visible: true},
        {key: 'doc', selector: '.campo_doc', width: '.5fr', visible: Number(preferences.check_dni ?? 1) === 1},
        {key: 'org', selector: '.campo_org', width: '1fr', visible: Number(preferences.check_org ?? 1) === 1},
        {key: 'rama', selector: '.campo_rama', width: '.5fr', visible: Number(preferences.check_rama ?? 1) === 1},
        {key: 'req_event', selector: '.campo_req_eventuales', width: '.25fr', visible: Number(preferences.check_req_event ?? 1) === 1},
        {key: 'req_fijos', selector: '.campo_req_fijos', width: '.25fr', visible: Number(preferences.check_req_fijos ?? 1) === 1}
    ];
    const visibleColumns = columns.filter(column => column.visible);
    const gridTemplateColumns = visibleColumns.map(column => column.width).join(' ');

    rows.forEach((row) => {
        row.style.gridTemplateColumns = gridTemplateColumns;

        columns.forEach((column) => {
            const cell = row.querySelector(column.selector);
            if(cell){
                cell.style.display = column.visible ? 'flex' : 'none';
            }
        });
    });
}

function areRequirementsComplete(requirements){
    const requirementList = Array.isArray(requirements) ? requirements : [];
    return requirementList.every(req => Boolean(req.Marcado));
}

function isDateExpired(dateValue){
    if(!dateValue){return true;}
    const [year,month,day] = String(dateValue).split('-').map(Number);
    if(!year || !month || !day){return true;}

    const today = new Date();
    const todayDate = new Date(today.getFullYear(),today.getMonth(),today.getDate());
    const validityDate = new Date(year,month - 1,day);

    return validityDate < todayDate;
}

function isFixedRequirementComplete(req){
    return Boolean(req.Marcado) && !isDateExpired(req.ValidoHasta);
}

function areFixedRequirementsComplete(requirements){
    const requirementList = Array.isArray(requirements) ? requirements : [];
    return requirementList.every(req => isFixedRequirementComplete(req));
}

function updateFixedRequirementExpiredState(row){
    if(!row){return;}
    const checkbox = row.querySelector('.req_check input');
    const validityInput = row.querySelector('.req_validity');
    const isExpired = Boolean(checkbox && checkbox.checked) && isDateExpired(validityInput ? validityInput.value : '');
    row.classList.toggle('vencido',isExpired);
    row.title = isExpired ? 'Requisito fijo vencido. Actualizá la fecha válido hasta.' : '';
}

function setRequirementSummaryCircle(row,cellSelector,isComplete){
    if(!row){return;}
    const circle = row.querySelector(`${cellSelector} .circulo_requisito`);
    if(!circle){return;}
    circle.classList.toggle('completo',Boolean(isComplete));
    circle.classList.toggle('incompleto',!Boolean(isComplete));
}

function getCurrentNominaPreferenceChecks(){
    const inputsCheck = document.querySelectorAll('.panel_acred.acred_config .input_columna input');
    if(inputsCheck.length > 0){
        return getNominaPreferenceFormData(inputsCheck);
    }

    return {
        check_dni: 1,
        check_org: 1,
        check_rama: 1,
        check_req_event: 1,
        check_req_fijos: 1
    };
}

function normalizeOrgCode(value){
    const digits = String(value || '').replace(/\D/g, '');
    if(digits == ''){
        return '';
    }
    return digits.padStart(4,'0');
}

function applyOrgCodeFormatting(input){
    if(!input){return;}

    input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '');
    });
    input.addEventListener('blur', () => {
        input.value = normalizeOrgCode(input.value);
    });
}

function listenImportMembersButtom(){
    const formMiembros = document.querySelector('.form_miembros');
    if(formMiembros){
        
        const inputFile = formMiembros.querySelector('.inputExcel');
        const botonFile = formMiembros.querySelector('.boton_file');
        const textoBotonFile = botonFile.querySelector('p');
    
        botonFile.addEventListener('click', function () {
            inputFile.click();
        });
    
        botonFile.addEventListener('drop', function (event) {
            event.preventDefault();
            handleDrop(event);
            botonFile.classList.remove('hover');
        });
    
        botonFile.addEventListener('dragover', function (event) {
            event.preventDefault();
            botonFile.classList.add('hover');
        });
        
        botonFile.addEventListener('dragleave', function (event) {
            event.preventDefault();
            botonFile.classList.remove('hover');
        });
    
        inputFile.addEventListener('change', function () {
            if (this.files.length > 0) {
                const fileName = this.files[0]['name'];
                if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
                    showAlert('error','Selecciona un archivo Excel (.xls o .xlsx)')
                    this.value = ''; // Resetea el input
                    textoBotonFile.innerHTML = 'Seleccione una Nómina';
                    return;
                }
                textoBotonFile.innerHTML = fileName;
            }else{
                textoBotonFile.innerHTML = 'Seleccione una nómina';
            }
    
        });
        function handleDrop(event) {
            var files = event.dataTransfer.files;
            if (files.length > 0) {
                inputFile.files = files;
                inputFile.dispatchEvent(new Event('change'));
            }
        }
    }

}

function listenNominaAttendanceChecks(){
    const listaMiembros = document.querySelector('.lista_miembros');
    if(!listaMiembros){return;}

    listaMiembros.addEventListener('change', async (event) => {
        const input = event.target.closest('.campo_asistencia input[type="checkbox"]');
        if(!input){return;}

        const row = input.closest('.row_miembro:not(.header_miembro)');
        if(!row){return;}

        const previousValue = row.dataset.asistencia === '1';
        const saved = await saveNominaMemberAttendance(row.dataset.doc,input.checked);
        if(saved){
            row.dataset.asistencia = input.checked ? '1' : '0';
            applyCurrentMemberTableSort(listaMiembros);
            showAlert('success','Asistencia actualizada correctamente');
        }else{
            input.checked = previousValue;
        }
    });
}

async function saveNominaMemberAttendance(doc,asistencia){
    try {
        const response = await fetch('/api/saveMemberAttendance.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'Doc':doc,
                'NomId':nominaNr,
                'Asistencia':asistencia
            })
        });
        const data = await response.json();

        if(data['response'] == 200){
            return true;
        }

        showAlert('error',data['error'] || 'Error al guardar asistencia');
    } catch (error) {
        console.error('Error en la solicitud:', error);
        showAlert('error','Error al guardar asistencia');
    }

    return false;
}

function listenQuickNominaSearch(){
    const quickSearch = document.querySelector('.buscador_rapido input');
    if(!quickSearch){return;}

    quickSearch.addEventListener('input', () => {
        quickSearch.value = quickSearch.value.replace(/\D/g, '');
    });

    quickSearch.addEventListener('keydown', (event) => {
        if(event.key !== 'Enter'){return;}

        event.preventDefault();
        processQuickNominaSearch(quickSearch.value);
        quickSearch.value = '';
    });

    function processQuickNominaSearch(value){
        const code = String(value || '').replace(/\D/g, '');
        if(code == ''){
            return;
        }

        if(code.length == 4){
            handleQuickOrgCodeScan(normalizeOrgCode(code));
            return;
        }

        if(code.length >= 7 && code.length <= 10){
            document.dispatchEvent(new CustomEvent('openMemberDetail', {
                detail: {
                    doc: code,
                    markAttendance: true,
                    scrollToRow: true
                }
            }));
            return;
        }

                showAlert('error','Código no reconocido');
    }

    function handleQuickOrgCodeScan(orgCode){
        document.dispatchEvent(new CustomEvent('quickOrgCodeScan', {
            detail: {
                orgCode: orgCode
            }
        }));
    }
}

function listenOrgScanModal(){
    if(typeof nominaNr === 'undefined'){return;}

    const modal = document.querySelector('.form_miembro_indv.org_scan');
    const listaMiembros = document.querySelector('.lista_miembros');
    const layout = document.querySelector('.layout');
    if(!modal || !listaMiembros || !layout){return;}

    const title = modal.querySelector('.org_scan_title');
    const count = modal.querySelector('.org_scan_count');
    const list = modal.querySelector('.org_scan_list');
    const headerRow = modal.querySelector('.org_scan_header_row');
    const btnClose = modal.querySelector('.btn_x');
    const btnCancel = modal.querySelector('.org_scan_actions .cancelar');
    const btnSave = modal.querySelector('.org_scan_actions .guardar');
    const loader = modal.querySelector('.cont_loader');

    const orgScanColumns = [
        {selector: '.campo_asistencia', width: '4.5rem', visible: true},
        {selector: '.campo_nombre', width: '1fr', visible: true},
        {selector: '.campo_doc', width: '8rem', mainSelector: '.campo_doc'},
        {selector: '.campo_rama', width: '9rem', mainSelector: '.campo_rama'},
        {selector: '.campo_req_eventuales', width: '4.5rem', mainSelector: '.campo_req_eventuales'},
        {selector: '.campo_req_fijos', width: '4.5rem', mainSelector: '.campo_req_fijos'}
    ];

    function getColumnVisibility(){
        const mainHeader = listaMiembros.querySelector('.header_miembro');

        return orgScanColumns.map(column => {
            if(!column.mainSelector){return {...column, visible: true};}

            const mainCell = mainHeader && mainHeader.querySelector(column.mainSelector);
            const visible = mainCell ? getComputedStyle(mainCell).display !== 'none' : true;
            return {...column, visible};
        });
    }

    function applyOrgScanColumns(columns){
        const gridTemplateColumns = columns.filter(column => column.visible).map(column => column.width).join(' ');

        [headerRow, ...list.querySelectorAll('.org_scan_row')].forEach(row => {
            if(!row){return;}

            row.style.gridTemplateColumns = gridTemplateColumns;
            columns.forEach(column => {
                const cell = row.querySelector(column.selector);
                if(cell){cell.style.display = column.visible ? '' : 'none';}
            });
        });
    }

    document.addEventListener('quickOrgCodeScan', event => {
        const orgCode = event.detail && event.detail.orgCode;
        if(!orgCode){return;}

        if(typeof nominaFinalizada !== 'undefined' && nominaFinalizada){
            showAlert('error','La nómina está finalizada, no se puede modificar la asistencia');
            return;
        }

        openOrgScanModal(orgCode);
    });

    btnClose.addEventListener('click', closeModal);
    btnCancel.addEventListener('click', closeModal);
    layout.addEventListener('click', () => {
        if(modal.classList.contains('mostrar')){closeModal();}
    });

    btnSave.addEventListener('click', async () => {
        const presentes = Array.from(list.querySelectorAll('.org_scan_row'))
            .filter(item => item.querySelector('input[type="checkbox"]').checked)
            .map(item => item.dataset.doc);

        if(presentes.length === 0){
            showAlert('error','No hay ningún miembro tildado para marcar presente');
            return;
        }

        loader.classList.add('loading');
        try {
            const response = await fetch('/api/saveOrgAttendance.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'NomId': nominaNr,
                    'Presentes': presentes
                })
            });
            const data = await response.json();

            if(data['response'] == 200){
                presentes.forEach(doc => marcarPresenteEnTabla(doc));
                applyCurrentMemberTableSort(listaMiembros);
                showAlert('success','Asistencia actualizada correctamente');
                closeModal();
            }else{
                showAlert('error',data['error'] || 'Error al guardar asistencia');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al guardar asistencia');
        }
        loader.classList.remove('loading');
    });

    function openOrgScanModal(orgCode){
        const rows = Array.from(listaMiembros.querySelectorAll(`.row_miembro:not(.header_miembro)[data-cod-org="${orgCode}"]`));

        if(rows.length === 0){
            showAlert('error','No se encontraron miembros de ese organismo en la nómina');
            return;
        }

        const orgName = rows[0].dataset.organismo || '';
        title.textContent = orgCode + (orgName ? ' — ' + orgName : '');
        count.textContent = rows.length + (rows.length === 1 ? ' miembro' : ' miembros');

        list.innerHTML = '';
        rows.forEach(row => list.appendChild(buildOrgScanRow(row)));
        applyOrgScanColumns(getColumnVisibility());

        modal.classList.add('mostrar');
        modal.classList.remove('ocultar');
        layout.classList.add('mostrar');
    }

    function buildOrgScanRow(row){
        const item = document.createElement('div');
        item.className = 'org_scan_row';
        item.dataset.doc = row.dataset.doc;

        const codRama = (row.dataset.rama || '').replace(/\d/g,'').toLowerCase();
        const ramaTexto = row.querySelector('.campo_rama p') ? row.querySelector('.campo_rama p').textContent : '';
        const reqEventualCompleto = row.querySelector('.campo_req_eventuales .circulo_requisito.completo') !== null;
        const reqFijoCompleto = row.querySelector('.campo_req_fijos .circulo_requisito.completo') !== null;

        item.innerHTML = `
            <div class="campo campo_asistencia" title="Asistencia">
                <label class="switch attendance_check">
                    <input type="checkbox" checked>
                    <span class="checkmark"></span>
                </label>
            </div>
            <div class="campo campo_nombre"><p></p></div>
            <div class="campo campo_doc"><p></p></div>
            <div class="campo campo_rama ${codRama}"><p></p></div>
            <div class="campo campo_req_eventuales" title="Requisitos eventuales">
                <div class="circulo_requisito ${reqEventualCompleto ? 'completo' : 'incompleto'}"></div>
            </div>
            <div class="campo campo_req_fijos" title="Requisitos fijos">
                <div class="circulo_requisito ${reqFijoCompleto ? 'completo' : 'incompleto'}"></div>
            </div>
        `;
        item.querySelector('.campo_nombre p').textContent = row.dataset.nombre || '';
        item.querySelector('.campo_doc p').textContent = row.dataset.doc || '';
        item.querySelector('.campo_rama p').textContent = ramaTexto;

        return item;
    }

    function marcarPresenteEnTabla(doc){
        const row = listaMiembros.querySelector(`.row_miembro:not(.header_miembro)[data-doc="${doc}"]`);
        if(!row){return;}

        const input = row.querySelector('.campo_asistencia input[type="checkbox"]');
        if(input){input.checked = true;}
        row.dataset.asistencia = '1';
    }

    function closeModal(){
        modal.classList.remove('mostrar');
        modal.classList.add('ocultar');
        layout.classList.remove('mostrar');
    }
}

function showMemberForms(){
    const formMiembros = document.querySelector('.form_miembro_indv.create');
    
    if(formMiembros){
        showCreateMemberForm();
    }
}

function showCreateMemberForm(){
    const formMiembros = document.querySelector('.form_miembro_indv.create');
    const btn_indv = document.querySelector('.cont_individual');
    if(!formMiembros || !btn_indv){return;}

    const btn_x = formMiembros.querySelector('.btn_x');
    const doc_input = formMiembros.querySelector('.campo.documento input');
    // const tel_input = formMiembros.querySelector('.campo.telefono input');
    const layout = document.querySelector('.layout');

    btn_indv.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseMemberFields();
        }else{
            formMiembros.classList.add('mostrar');
            formMiembros.classList.remove('ocultar'); 
            layout.classList.add('mostrar');
        }
    })

    btn_x.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseMemberFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseMemberFields();
        }
    })

    let memberSearchTimeout;

    doc_input.addEventListener("input", () => {
        doc_input.value = doc_input.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
        searchMemberByDoc(doc_input.value);
    });
    const cod_org_input = formMiembros.querySelector('.campo.cod_org input');
    applyOrgCodeFormatting(cod_org_input);
    // tel_input.addEventListener("input", () => {
    //     tel_input.value = tel_input.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
    // });

    function raiseMemberFields(){
        const inputNombre = formMiembros.querySelector("#nombre_create");
        const inputDoc = formMiembros.querySelector("#documento_create");
        const inputCodOrg = formMiembros.querySelector("#cod_org_create");
        const inputOrg = formMiembros.querySelector("#org_create");
        const inputRama = formMiembros.querySelector("#rama_create");
        const inputObservacionManual = formMiembros.querySelector("#observacion_manual_create");
        // const inputTelefono = formMiembros.querySelector("#telefono_create");
        
        inputNombre.value = '';
        inputDoc.value = '';
        inputCodOrg.value = '';
        inputOrg.value = '';
        inputObservacionManual.value = '';
        // inputTelefono.value = '';
        inputRama.value = 0;

    }

    function searchMemberByDoc(doc){
        clearTimeout(memberSearchTimeout);

        if(doc.length < 7 || doc.length > 10){
            return;
        }

        memberSearchTimeout = setTimeout(() => {
            fetch('/api/getMemberByDoc.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({'Doc':doc})
            })
            .then(response => response.json())
            .then(data => {
                if(data['response'] == 200 && data['data'] && doc_input.value == doc){
                    autocompleteMemberFields(data['data']);
                    showAlert('success','Datos de miembro autocompletados');
                }
            })
            .catch(error => {
                console.error('Error en la consulta de miembro:', error);
            });
        }, 500);
    }

    function autocompleteMemberFields(member){
        const inputNombre = formMiembros.querySelector("#nombre_create");
        const inputCodOrg = formMiembros.querySelector("#cod_org_create");
        const inputOrg = formMiembros.querySelector("#org_create");
        const inputRama = formMiembros.querySelector("#rama_create");
        const inputObservacionManual = formMiembros.querySelector("#observacion_manual_create");

        inputNombre.value = member.Nombre || '';
        inputCodOrg.value = normalizeOrgCode(member.CodOrganismo || '');
        inputOrg.value = member.NombreOrganismo || '';
        inputObservacionManual.value = member.ObservacionManual || '';

        if(member.CodRama && inputRama.querySelector(`option[value="${member.CodRama}"]`)){
            inputRama.value = member.CodRama;
        }
    }
}

function tableSearchMembers(){
    const searchBox = document.querySelector('.buscador_miembros input');
    if(searchBox){
        
        searchBox.addEventListener('input',searchOnTable);
        
        function searchOnTable(){
            const tableRows = document.querySelectorAll(".lista_miembros .row_miembro:not(.header_miembro)");

            const searchData = quitarAcentos(searchBox.value.toLowerCase());
            const buscarVacio = searchData === '';

            tableRows.forEach(row => {
                const nombre = row.querySelector('.campo_nombre p').textContent || '';
                const doc    = row.querySelector('.campo_doc p').textContent    || '';
                const org    = row.querySelector('.campo_org p').textContent    || '';

                let rama = '';
                const pRama = row.querySelector('.campo_rama p');
                if (pRama) {
                    rama = pRama.textContent;
                }else {
                    const selectRama = row.querySelector('.campo_rama select');
                    if (selectRama) {
                        rama = selectRama.options[selectRama.selectedIndex].textContent;
                    }
                }

                const tableData = quitarAcentos((nombre + ' ' + doc + ' ' + org + ' ' + rama).toLowerCase());

                // toggle ocultar si no coincide (o mostrar todo si input vacío)
                const noCoincide = tableData.indexOf(searchData) < 0;
                row.classList.toggle('oculta', !buscarVacio && noCoincide);
            })
        }
    }

}

function showMemberDetailModal(){
    if(typeof nominaNr === 'undefined'){
        return;
    }

    const listaMiembros = document.querySelector('.lista_miembros');
    const formDetail = document.querySelector('.form_miembro_indv.detail:not(.general_member_detail)');

    if(!listaMiembros || !formDetail){return;}

    const layout = document.querySelector('.layout');
    const btnClose = formDetail.querySelector('.btn_x');
    const btnSave = formDetail.querySelector('.btn_submit.guardar');
    const btnDelete = formDetail.querySelector('.btn_submit.eliminar');
    const deleteConfirm = formDetail.querySelector('.detail_delete_confirm');
    const btnConfirmDelete = formDetail.querySelector('.confirm_delete_yes');
    const btnCancelDelete = formDetail.querySelector('.confirm_delete_no');
    const loader = document.querySelector('.panel_acred .cont_loader_miembro');
    applyOrgCodeFormatting(formDetail.querySelector('#detail_cod_org'));
    let initialModalState = null;

    const isReadonly = typeof nominaFinalizada !== 'undefined' && nominaFinalizada;
    if(isReadonly){
        formDetail.classList.add('readonly');
        formDetail.querySelectorAll('.detalle_miembro input, .detalle_miembro textarea').forEach(el => {
            if(el.type !== 'hidden'){el.readOnly = true;}
        });
        formDetail.querySelectorAll('.detalle_miembro select').forEach(el => {el.disabled = true;});
        const asistenciaInput = formDetail.querySelector('#detail_asistencia');
        if(asistenciaInput){asistenciaInput.disabled = true;}
    }

    listaMiembros.addEventListener('click', async (event) => {
        const nombre = event.target.closest('.campo_nombre');
        const row = event.target.closest('.row_miembro:not(.header_miembro)');

        if(!nombre || !row){return;}

        await openMemberDetailRow(row);
    });

    document.addEventListener('openMemberDetail', async (event) => {
        const detail = event.detail || {};
        const doc = String(detail.doc || '').replace(/\D/g, '');
        const row = listaMiembros.querySelector(`.row_miembro:not(.header_miembro)[data-doc="${doc}"]`);

        if(!row){
            showAlert('error','Miembro no encontrado en la nómina');
            return;
        }

        await openMemberDetailRow(row,{
            markAttendance: Boolean(detail.markAttendance),
            scrollToRow: Boolean(detail.scrollToRow)
        });
    });

    btnClose.addEventListener('click', closeDetailModal);
    layout.addEventListener('click', () => {
        if(formDetail.classList.contains('mostrar')){
            closeDetailModal();
        }
    });

    btnSave.addEventListener('click', async () => {
        if(isReadonly){return;}

        const modalState = getMemberModalState();
        if(!modalState){return;}

        const changes = getMemberModalChanges(modalState);
        if(!Object.values(changes).some(Boolean)){
            showAlert('error','No hay cambios en los datos');
            return;
        }

        loader.classList.add('loading');

        const modalSaved = await saveMemberModal(modalState,changes);
        if(modalSaved){
            updateSelectedMemberRow(modalState.Member,modalState);
            showAlert('success','Miembro actualizado correctamente');
            closeDetailModal();
        }

        loader.classList.remove('loading');
    });

    btnDelete.addEventListener('click', async () => {
        if(isReadonly){return;}

        deleteConfirm.classList.add('mostrar');
    });

    btnCancelDelete.addEventListener('click', () => {
        deleteConfirm.classList.remove('mostrar');
    });

    btnConfirmDelete.addEventListener('click', async () => {
        const member = getDetailMemberFields(false);
        if(!member){return;}

        loader.classList.add('loading');

        try {
            const response = await fetch('/api/deleteMemberByForm.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({'Doc':member.Doc,'NomId':nominaNr})
            });
            const data = await response.json();

            if(data['response'] == 200){
                deleteSelectedMemberRow();
                showAlert('success','Miembro eliminado correctamente');
                closeDetailModal();
            }else{
                showAlert('error','Error al eliminar miembro');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al eliminar miembro');
        }

        loader.classList.remove('loading');
    });

    function openDetailModal(){
        formDetail.classList.add('mostrar');
        formDetail.classList.remove('ocultar');
        layout.classList.add('mostrar');
    }

    async function openMemberDetailRow(row,options = {}){
        const currentSelected = listaMiembros.querySelector('.row_miembro.selected');
        if(currentSelected && currentSelected !== row){
            currentSelected.classList.remove('selected');
        }

        row.classList.add('selected');
        if(options.scrollToRow){
            row.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
        openDetailModal();
        setDetailLoading();
        fillMemberDetailFromRow(row);
        await loadMemberDetail(row.dataset.doc);

        if(options.markAttendance){
            formDetail.querySelector('#detail_asistencia').checked = true;
        }
    }

    function closeDetailModal(){
        formDetail.classList.remove('mostrar');
        formDetail.classList.add('ocultar');
        layout.classList.remove('mostrar');
        const selected = listaMiembros.querySelector('.row_miembro.selected');
        if(selected){selected.classList.remove('selected');}
        deleteConfirm.classList.remove('mostrar');
        initialModalState = null;
        clearRequirementTables();
    }

    function setDetailLoading(){
        const eventuales = formDetail.querySelector('.req_body.eventuales');
        const fijos = formDetail.querySelector('.req_body.fijos');

        eventuales.innerHTML = '<div class="req_empty"><p>Cargando requisitos...</p></div>';
        fijos.innerHTML = '<div class="req_empty"><p>Cargando requisitos...</p></div>';
    }

    function fillMemberDetailFromRow(row){
        const campoCodRama = row.querySelector('.campo_codrama p');
        const rama = row.dataset.rama || (campoCodRama ? campoCodRama.textContent : '');

        formDetail.querySelector('#detail_internal_id').value = row.dataset.internal || row.querySelector('.campo_internal p').textContent;
        formDetail.querySelector('#detail_doc').value = row.dataset.doc || row.querySelector('.campo_doc p').textContent;
        formDetail.querySelector('#detail_nombre').value = row.dataset.nombre || row.querySelector('.campo_nombre p').textContent;
        formDetail.querySelector('#detail_cod_org').value = row.dataset.codOrg || '';
        formDetail.querySelector('#detail_org').value = row.dataset.organismo || '';
        formDetail.querySelector('#detail_rama').value = rama.replace(/^\d+-/, '');
        formDetail.querySelector('#detail_observacion_importada').value = '';
        formDetail.querySelector('#detail_observacion_manual').value = '';
        formDetail.querySelector('#detail_asistencia').checked = row.dataset.asistencia === '1';
    }

    async function loadMemberDetail(doc){
        try {
            const response = await fetch('/api/getMemberDetail.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({'Doc':doc,'NomId':nominaNr})
            });
            const data = await response.json();

            if(data['response'] == 200){
                fillMemberDetail(data['data']['Member']);
                renderEventualRequirements(data['data']['RequisitosEventuales']);
                renderFixedRequirements(data['data']['RequisitosFijos']);
                initialModalState = getMemberModalState(false);
            }else{
                clearRequirementTables('No se pudieron cargar los requisitos');
            }
        } catch (error) {
            console.error('Error en la consulta de miembro:', error);
            clearRequirementTables('No se pudieron cargar los requisitos');
        }
    }

    function fillMemberDetail(member){
        formDetail.querySelector('#detail_internal_id').value = member.InternalId;
        formDetail.querySelector('#detail_doc').value = member.Doc;
        formDetail.querySelector('#detail_nombre').value = member.Nombre;
        formDetail.querySelector('#detail_cod_org').value = normalizeOrgCode(member.CodOrganismo);
        formDetail.querySelector('#detail_org').value = member.NombreOrganismo;
        formDetail.querySelector('#detail_rama').value = member.CodRama;
        formDetail.querySelector('#detail_observacion_importada').value = member.ObservacionImportada || '';
        formDetail.querySelector('#detail_observacion_manual').value = member.ObservacionManual || '';
        formDetail.querySelector('#detail_asistencia').checked = member.Asistencia == 1;
    }

    function renderEventualRequirements(requirements){
        const body = formDetail.querySelector('.req_body.eventuales');
        body.innerHTML = '';

        if(!requirements || requirements.length == 0){
            renderEventualRequirementExamples(body);
            return;
        }

        requirements.forEach(req => {
            const row = document.createElement('div');
            row.classList.add('req_row','eventual');
            row.dataset.id = req.IdRequisito;
            row.innerHTML = `
                <p class="req_name"></p>
                <div class="req_link_field">
                    <input type="url" value="" placeholder="URL">
                    <a href="#" target="_blank" rel="noopener" title="Abrir adjunto">
                        <i class="fa-solid fa-link"></i>
                    </a>
                </div>
                <label class="switch req_check">
                    <input type="checkbox" ${req.Marcado == 1 ? 'checked' : ''}>
                    <span class="checkmark"></span>
                </label>
            `;
            row.querySelector('.req_name').textContent = req.Nombre;
            const urlInput = row.querySelector('.req_link_field input');
            const urlLink = row.querySelector('.req_link_field a');
            urlInput.value = req.Adjunto || '';
            updateRequirementLink(urlLink,urlInput.value);
            urlInput.addEventListener('input', () => updateRequirementLink(urlLink,urlInput.value));
            if(isReadonly){
                urlInput.disabled = true;
                row.querySelector('.req_check input').disabled = true;
            }
            body.appendChild(row);
        });
    }

    function renderFixedRequirements(requirements){
        const body = formDetail.querySelector('.req_body.fijos');
        body.innerHTML = '';

        if(!requirements || requirements.length == 0){
            renderFixedRequirementExamples(body);
            return;
        }

        requirements.forEach(req => {
            const row = document.createElement('div');
            row.classList.add('req_row','fixed');
            row.dataset.id = req.IdRequisito;
            row.dataset.defaultValidity = req.DefaultValidity || '';
            row.innerHTML = `
                <p class="req_name"></p>
                <div class="req_link_field">
                    <input type="url" value="" placeholder="URL">
                    <a href="#" target="_blank" rel="noopener" title="Abrir adjunto">
                        <i class="fa-solid fa-link"></i>
                    </a>
                </div>
                <input class="req_validity" type="date" value="${req.ValidoHasta || ''}">
                <label class="switch req_check">
                    <input type="checkbox" ${req.Marcado == 1 ? 'checked' : ''}>
                    <span class="checkmark"></span>
                </label>
            `;
            row.querySelector('.req_name').textContent = req.Nombre;
            const urlInput = row.querySelector('.req_link_field input');
            const urlLink = row.querySelector('.req_link_field a');
            urlInput.value = req.Adjunto || '';
            updateRequirementLink(urlLink,urlInput.value);
            urlInput.addEventListener('input', () => updateRequirementLink(urlLink,urlInput.value));
            row.querySelector('.req_check input').addEventListener('change', event => {
                const validityInput = row.querySelector('.req_validity');
                if(event.target.checked && !validityInput.value && row.dataset.defaultValidity){
                    validityInput.value = row.dataset.defaultValidity;
                }
                updateFixedRequirementExpiredState(row);
            });
            row.querySelector('.req_validity').addEventListener('change', () => updateFixedRequirementExpiredState(row));
            updateFixedRequirementExpiredState(row);
            if(isReadonly){
                urlInput.disabled = true;
                row.querySelector('.req_validity').disabled = true;
                row.querySelector('.req_check input').disabled = true;
            }
            body.appendChild(row);
        });
    }

    function updateRequirementLink(link,url){
        if(url){
            link.href = url;
            link.classList.remove('disabled');
        }else{
            link.href = '#';
            link.classList.add('disabled');
        }
    }

    function renderEventualRequirementExamples(body){
        const examples = [
            {'Nombre':'Autorización de salida','Adjunto':'https://ejemplo.com/autorizacion.pdf','Marcado':true},
            {'Nombre':'Pago de actividad','Adjunto':'','Marcado':false}
        ];

        body.innerHTML = '';
        examples.forEach(req => {
            const row = document.createElement('div');
            row.classList.add('req_row','eventual','example');
            row.innerHTML = `
                <p class="req_name"></p>
                <div class="req_link_field">
                    <input type="url" value="${req.Adjunto}" placeholder="URL" disabled>
                    <a href="#" target="_blank" rel="noopener" title="Abrir adjunto" class="${req.Adjunto ? '' : 'disabled'}">
                        <i class="fa-solid fa-link"></i>
                    </a>
                </div>
                <label class="switch req_check">
                    <input type="checkbox" ${req.Marcado ? 'checked' : ''} disabled>
                    <span class="checkmark"></span>
                </label>
            `;
            row.querySelector('.req_name').textContent = req.Nombre;
            if(req.Adjunto){row.querySelector('.req_link_field a').href = req.Adjunto;}
            body.appendChild(row);
        });
    }

    function renderFixedRequirementExamples(body){
        const examples = [
            {
                'Nombre':'Ficha médica',
                'Adjunto':'https://ejemplo.com/ficha-medica.pdf',
                'ValidoHasta':'2026-12-31',
                'Marcado':true
            },
            {
                'Nombre':'Autorización anual',
                'Adjunto':'',
                'ValidoHasta':'2026-03-31',
                'Marcado':false
            }
        ];

        body.innerHTML = '';
        examples.forEach(req => {
            const row = document.createElement('div');
            row.classList.add('req_row','fixed','example');
            row.innerHTML = `
                <p class="req_name"></p>
                <div class="req_link_field">
                    <input type="url" value="" placeholder="URL" disabled>
                    <a href="#" target="_blank" rel="noopener" title="Abrir adjunto">
                        <i class="fa-solid fa-link"></i>
                    </a>
                </div>
                <input class="req_validity" type="date" value="${req.ValidoHasta}" disabled>
                <label class="switch req_check">
                    <input type="checkbox" ${req.Marcado ? 'checked' : ''} disabled>
                    <span class="checkmark"></span>
                </label>
            `;
            row.querySelector('.req_name').textContent = req.Nombre;
            const urlInput = row.querySelector('.req_link_field input');
            const urlLink = row.querySelector('.req_link_field a');
            urlInput.value = req.Adjunto;
            updateRequirementLink(urlLink,req.Adjunto);
            body.appendChild(row);
        });
    }

    function clearRequirementTables(message = ''){
        const eventuales = formDetail.querySelector('.req_body.eventuales');
        const fijos = formDetail.querySelector('.req_body.fijos');

        eventuales.innerHTML = message ? `<div class="req_empty"><p>${message}</p></div>` : '';
        fijos.innerHTML = message ? `<div class="req_empty"><p>${message}</p></div>` : '';
    }

    function getDetailMemberFields(validate = true){
        const campoDoc = formDetail.querySelector('#detail_doc');
        const campoNombre = formDetail.querySelector('#detail_nombre');
        const campoCodOrg = formDetail.querySelector('#detail_cod_org');
        const campoOrg = formDetail.querySelector('#detail_org');
        const campoRama = formDetail.querySelector('#detail_rama');
        const nombreRama = campoRama.options[campoRama.selectedIndex].text;
        const selectedRow = listaMiembros.querySelector('.row_miembro.selected');

        if(validate){
            let errorMsg = 'Faltó completar ';
            let error = false;

            if(campoNombre.value == ''){
                errorMsg += 'Nombre. ';
                error = true;
            }
            if(campoCodOrg.value == ''){
                errorMsg += 'Nro. Organismo. ';
                error = true;
            }
            if(campoOrg.value == ''){
                errorMsg += 'Organismo. ';
                error = true;
            }
            if(campoRama.value == 0){
                errorMsg += 'Rama. ';
                error = true;
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
        }

        return {
            'InternalId':formDetail.querySelector('#detail_internal_id').value,
            'Doc':campoDoc.value,
            'Nombre':campoNombre.value,
            'Rama':campoRama.value,
            'NombreRama':nombreRama,
            'CodOrg':normalizeOrgCode(campoCodOrg.value),
            'Organismo':campoOrg.value,
            'ObservacionImportada':formDetail.querySelector('#detail_observacion_importada').value,
            'ObservacionManual':formDetail.querySelector('#detail_observacion_manual').value.trim(),
            'Active':selectedRow ? selectedRow.classList.contains('activo') : true,
            'Asistencia':formDetail.querySelector('#detail_asistencia').checked
        };
    }

    function getMemberModalState(validate = true){
        const member = getDetailMemberFields(validate);
        if(!member){return false;}

        const requirements = getMemberRequirementsPayload();

        return {
            'Member': member,
            'Attendance': {
                'Doc': member.Doc,
                'NomId': nominaNr,
                'Asistencia': member.Asistencia
            },
            ...requirements
        };
    }

    function normalizeMemberModalState(state){
        if(!state){return null;}

        return {
            'Member': {
                'InternalId': String(state.Member.InternalId || ''),
                'Doc': String(state.Member.Doc || ''),
                'Nombre': String(state.Member.Nombre || '').trim(),
                'Rama': String(state.Member.Rama || ''),
                'CodOrg': normalizeOrgCode(state.Member.CodOrg),
                'Organismo': String(state.Member.Organismo || '').trim(),
                'ObservacionImportada': String(state.Member.ObservacionImportada || ''),
                'ObservacionManual': String(state.Member.ObservacionManual || '').trim(),
                'Active': Boolean(state.Member.Active)
            },
            'Attendance': {
                'Asistencia': Boolean(state.Attendance.Asistencia)
            },
            'RequisitosEventuales': normalizeRequirements(state.RequisitosEventuales),
            'RequisitosFijos': normalizeRequirements(state.RequisitosFijos)
        };
    }

    function normalizeRequirements(requirements){
        return [...requirements].map(req => {
            return {
                'IdRequisito': String(req.IdRequisito || ''),
                'Adjunto': String(req.Adjunto || '').trim(),
                'ValidoHasta': String(req.ValidoHasta || ''),
                'Marcado': Boolean(req.Marcado)
            };
        }).sort((a,b) => a.IdRequisito.localeCompare(b.IdRequisito));
    }

    function hasStateChanged(currentValue,initialValue){
        return JSON.stringify(currentValue) !== JSON.stringify(initialValue);
    }

    function getMemberModalChanges(currentState){
        const current = normalizeMemberModalState(currentState);
        const initial = normalizeMemberModalState(initialModalState);

        if(!initial){
            return {
                'Member': true,
                'Attendance': true,
                'EventualRequirements': true,
                'FixedRequirements': true
            };
        }

        return {
            'Member': hasStateChanged(current.Member,initial.Member),
            'Attendance': hasStateChanged(current.Attendance,initial.Attendance),
            'EventualRequirements': hasStateChanged(current.RequisitosEventuales,initial.RequisitosEventuales),
            'FixedRequirements': hasStateChanged(current.RequisitosFijos,initial.RequisitosFijos)
        };
    }

    function getMemberRequirementsPayload(){
        const eventuales = Array.from(formDetail.querySelectorAll('.req_body.eventuales .req_row:not(.example)')).map(row => {
            return {
                'IdRequisito':row.dataset.id,
                'Adjunto':row.querySelector('.req_link_field input').value,
                'Marcado':row.querySelector('input[type="checkbox"]').checked
            };
        });

        const fijos = Array.from(formDetail.querySelectorAll('.req_body.fijos .req_row:not(.example)')).map(row => {
            return {
                'IdRequisito':row.dataset.id,
                'Adjunto':row.querySelector('.req_link_field input').value,
                'ValidoHasta':row.querySelector('.req_validity').value,
                'Marcado':row.querySelector('input[type="checkbox"]').checked
            };
        });

        return {
            'RequisitosEventuales':eventuales,
            'RequisitosFijos':fijos
        };
    }

    async function saveMemberModal(modalState,changes){
        try {
            const response = await fetch('/api/saveMemberModal.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...modalState.Member,
                    'NomId':nominaNr,
                    'Changes':changes,
                    'RequisitosEventuales':modalState.RequisitosEventuales,
                    'RequisitosFijos':modalState.RequisitosFijos
                })
            });
            const data = await response.json();

            if(data['response'] == 200){
                return true;
            }

            showAlert('error',data['error'] || 'Error al actualizar miembro');
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al actualizar miembro');
        }

        return false;
    }

    async function saveMemberDetail(member){
        try {
            const response = await fetch('/api/editMemberByForm.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(member)
            });
            const data = await response.json();

            if(data['response'] == 200){
                return true;
            }

            showAlert('error',data['error'] || 'Error al actualizar miembro');
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al actualizar miembro');
        }

        return false;
    }

    async function saveMemberRequirements(doc){
        const requirements = getMemberRequirementsPayload();

        try {
            const response = await fetch('/api/saveMemberRequirements.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'Doc':doc,
                    'NomId':nominaNr,
                    ...requirements
                })
            });
            const data = await response.json();

            if(data['response'] == 200){
                return true;
            }

            showAlert('error',data['error'] || 'Error al guardar requisitos');
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al guardar requisitos');
        }

        return false;
    }

    function updateSelectedMemberRow(member,modalState = null){
        const row = listaMiembros.querySelector('.row_miembro.selected');
        if(!row){return;}

        const nombre = row.querySelector('.campo_nombre p');
        const doc = row.querySelector('.campo_doc p');
        const org = row.querySelector('.campo_org p');
        const rama = row.querySelector('.campo_rama');
        const ramaText = row.querySelector('.campo_rama p');
        const codRama = row.querySelector('.campo_codrama p');

        nombre.textContent = member.Nombre;
        doc.textContent = member.Doc;
        org.textContent = `${member.CodOrg}-${member.Organismo}`;
        ramaText.textContent = member.NombreRama;
        codRama.textContent = member.Rama;

        rama.className = '';
        rama.classList.add('campo','campo_rama',member.Rama.replace(/\d/g, '').toLowerCase());
        rama.title = member.NombreRama;

        row.dataset.doc = member.Doc;
        row.dataset.internal = member.InternalId;
        row.dataset.nombre = member.Nombre;
        row.dataset.codOrg = member.CodOrg;
        row.dataset.organismo = member.Organismo;
        row.dataset.rama = member.Rama;
        row.dataset.activo = member.Active ? '1' : '0';
        row.dataset.asistencia = member.Asistencia ? '1' : '0';

        const asistencia = row.querySelector('.campo_asistencia input[type="checkbox"]');
        if(asistencia){
            asistencia.checked = member.Asistencia;
        }

        row.classList.toggle('activo', member.Active);
        row.classList.toggle('inactivo', !member.Active);

        if(modalState){
            setRequirementSummaryCircle(row,'.campo_req_eventuales',areRequirementsComplete(modalState.RequisitosEventuales));
            setRequirementSummaryCircle(row,'.campo_req_fijos',areFixedRequirementsComplete(modalState.RequisitosFijos));
        }
        applyCurrentMemberTableSort(listaMiembros);
    }

    function deleteSelectedMemberRow(){
        const row = listaMiembros.querySelector('.row_miembro.selected');
        const emptyMessage = listaMiembros.querySelector('.emptyMessage');

        if(row){row.remove();}

        const rows = listaMiembros.querySelectorAll('.row_miembro:not(.header_miembro)');
        if(rows.length == 0 && emptyMessage){
            emptyMessage.style.display = 'block';
        }
    }
}

function sortMembersList(){
    document.querySelectorAll('.lista_miembros').forEach(table => {
        setupMemberTableSort(table);
    });
}

function setupMemberTableSort(table){
    const header = table.querySelector('.row_miembro.header_miembro');
    if(!header){return;}

    const sortableColumns = getMemberSortableColumns();

    Object.keys(sortableColumns).forEach(className => {
        const cell = header.querySelector(`.${className}`);
        if(!cell){return;}
        cell.classList.add('sortable_header');
        cell.dataset.sortKey = sortableColumns[className].key;
        cell.addEventListener('click', () => {
            const currentKey = table.dataset.sortKey || 'nombre';
            const currentDirection = table.dataset.sortDirection || 'asc';
            const nextDirection = currentKey === sortableColumns[className].key && currentDirection === 'asc' ? 'desc' : 'asc';
            sortMemberTable(table,sortableColumns[className],nextDirection);
        });
    });

    sortMemberTable(table,sortableColumns.campo_nombre,'asc');
}

function getMemberSortableColumns(){
    return {
        'campo_asistencia': {key:'asistencia', type:'boolean'},
        'campo_nombre': {key:'nombre', type:'text'},
        'campo_doc': {key:'doc', type:'number'},
        'campo_org': {key:'org', type:'text'},
        'campo_rama': {key:'rama', type:'rama'},
        'campo_req_eventuales': {key:'req_eventuales', type:'requirement'},
        'campo_req_fijos': {key:'req_fijos', type:'requirement'}
    };
}

function applyCurrentMemberTableSort(table){
    if(!table){return;}
    const columns = Object.values(getMemberSortableColumns());
    const currentKey = table.dataset.sortKey || 'nombre';
    const currentDirection = table.dataset.sortDirection || 'asc';
    const column = columns.find(item => item.key === currentKey) || getMemberSortableColumns().campo_nombre;
    sortMemberTable(table,column,currentDirection);
}

function sortMemberTable(table,column,direction){
    const rows = Array.from(table.querySelectorAll('.row_miembro:not(.header_miembro):not(.emptyMessage)'));
    const emptyMessage = table.querySelector('.emptyMessage');
    const directionModifier = direction === 'asc' ? 1 : -1;

    rows.sort((rowA,rowB) => {
        const stateCompare = compareMemberState(rowA,rowB);
        if(stateCompare !== 0){return stateCompare;}

        const valueA = getMemberSortValue(rowA,column);
        const valueB = getMemberSortValue(rowB,column);
        const compare = compareMemberValues(valueA,valueB,column.type);

        if(compare !== 0){
            return compare * directionModifier;
        }

        return compareMemberValues(getMemberSortValue(rowA,{key:'nombre'}),getMemberSortValue(rowB,{key:'nombre'}),'text');
    });

    rows.forEach(row => table.insertBefore(row,emptyMessage || null));
    table.dataset.sortKey = column.key;
    table.dataset.sortDirection = direction;
    updateMemberSortHeaders(table,column.key,direction);
}

function compareMemberState(rowA,rowB){
    const activeA = rowA.classList.contains('activo') ? 1 : 0;
    const activeB = rowB.classList.contains('activo') ? 1 : 0;
    return activeB - activeA;
}

function getMemberSortValue(row,column){
    if(column.key === 'asistencia'){
        const input = row.querySelector('.campo_asistencia input[type="checkbox"]');
        return input && input.checked ? 1 : 0;
    }
    if(column.key === 'nombre'){return row.dataset.nombre || getRowText(row,'.campo_nombre p');}
    if(column.key === 'doc'){return row.dataset.doc || getRowText(row,'.campo_doc p');}
    if(column.key === 'org'){return row.dataset.organismo || getRowText(row,'.campo_org p');}
    if(column.key === 'rama'){return row.dataset.rama || getRowText(row,'.campo_codrama p');}
    if(column.type === 'requirement'){
        const circle = row.querySelector(`.campo_${column.key} .circulo_requisito`);
        return circle && circle.classList.contains('completo') ? 1 : 0;
    }
    return '';
}

function getRowText(row,selector){
    const element = row.querySelector(selector);
    return element ? element.textContent : '';
}

function compareMemberValues(valueA,valueB,type){
    if(type === 'number' || type === 'boolean' || type === 'requirement'){
        return Number(valueA) - Number(valueB);
    }
    if(type === 'rama'){
        return compareRamaValues(String(valueA),String(valueB));
    }
    return quitarAcentos(String(valueA).toLowerCase()).localeCompare(quitarAcentos(String(valueB).toLowerCase()));
}

function compareRamaValues(valueA,valueB){
    const ordenRamas = ['MAN','UNI','CAM','ROV','EDU','SRAM'];
    const baseA = valueA.match(/[A-Za-z]+/) ? valueA.match(/[A-Za-z]+/)[0] : '';
    const baseB = valueB.match(/[A-Za-z]+/) ? valueB.match(/[A-Za-z]+/)[0] : '';
    const indexA = ordenRamas.indexOf(baseA);
    const indexB = ordenRamas.indexOf(baseB);
    const safeIndexA = indexA === -1 ? ordenRamas.length : indexA;
    const safeIndexB = indexB === -1 ? ordenRamas.length : indexB;

    if(safeIndexA !== safeIndexB){
        return safeIndexA - safeIndexB;
    }

    const numA = valueA.match(/\d+/) ? parseInt(valueA.match(/\d+/)[0],10) : 0;
    const numB = valueB.match(/\d+/) ? parseInt(valueB.match(/\d+/)[0],10) : 0;
    return numA - numB;
}

function updateMemberSortHeaders(table,activeKey,direction){
    table.querySelectorAll('.header_miembro .sortable_header').forEach(cell => {
        cell.classList.toggle('sort_active',cell.dataset.sortKey === activeKey);
        cell.classList.toggle('sort_desc',cell.dataset.sortKey === activeKey && direction === 'desc');
    });
}

function legacySortMembersList(){
    const lista_miembros = document.querySelector('.lista_miembros');
    if(lista_miembros){
        const row_miembros = lista_miembros.querySelectorAll('.row_miembro:not(.header_miembro)');
        if(row_miembros.length > 0){
            const sort_rama = document.querySelector('.btn_sort.sort_rama');
            const sort_name = document.querySelector('.btn_sort.sort_name');
            
            sort_name.addEventListener('click',()=>{
                const miembrosAct = Array.from(lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro).activo"));
                const miembrosInact = Array.from(lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro).inactivo"));
                const headerRow = lista_miembros.querySelector(".row_miembro.header_miembro");
                lista_miembros.innerHTML = "";
                lista_miembros.appendChild(headerRow);
                sort_rama.classList.remove('asc');
                sort_name.classList.toggle('asc');

                if(miembrosAct.length > 0){
                    sortAlphabetic(miembrosAct);
                }
                if(miembrosInact.length > 0){
                    sortAlphabetic(miembrosInact);
                }
            })

            const ordenRamas = ['MAN','UNI','CAM','ROV','EDU','SRAM'];
            sort_rama.addEventListener('click',()=>{
                const miembrosAct = Array.from(lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro).activo"));
                const miembrosInact = Array.from(lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro).inactivo"));
                const headerRow = lista_miembros.querySelector(".row_miembro.header_miembro");
                lista_miembros.innerHTML = "";
                lista_miembros.appendChild(headerRow);
                sort_name.classList.remove('asc');
                sort_rama.classList.toggle('asc');

                if(miembrosAct.length > 0){
                    sortByRama(miembrosAct);
                }
                if(miembrosInact.length > 0){
                    sortByRama(miembrosInact);
                }
            })

            function sortAlphabetic(miembros){
                let asc_sort = sort_name.classList.contains('asc');

                miembros.sort((a, b) => {
                    let nombreA = a.querySelector(".campo_nombre p").textContent.toLowerCase();
                    let nombreB = b.querySelector(".campo_nombre p").textContent.toLowerCase();

                    if(asc_sort){
                        return nombreA.localeCompare(nombreB);
                    }else{
                        return nombreB.localeCompare(nombreA);
                    }
                });
            
                miembros.forEach(miembro => lista_miembros.appendChild(miembro));
            }

            function sortByRama(miembros){
                let asc_sort = sort_rama.classList.contains('asc');

                miembros.sort((a, b) => {
                    let ramaA = a.querySelector(".campo_codrama p").textContent;
                    let ramaB = b.querySelector(".campo_codrama p").textContent;

                    let baseA = ramaA.match(/[A-Za-z]+/)[0]; 
                    let baseB = ramaB.match(/[A-Za-z]+/)[0]; 

                    // Extraer el número (si hay, sino 0)
                    let numA = ramaA.match(/\d+/) ? parseInt(ramaA.match(/\d+/)[0], 10) : 0;
                    let numB = ramaB.match(/\d+/) ? parseInt(ramaB.match(/\d+/)[0], 10) : 0;

                    let indexA = ordenRamas.indexOf(baseA);
                    let indexB = ordenRamas.indexOf(baseB);

                    // Ordenar primero por la posición en ordenRamas
                    if (indexA !== indexB) {
                        if(asc_sort){
                            return indexA - indexB;
                        }else{
                            return indexB - indexA;
                        }
                    }
                    // Si tienen la misma rama, ordenar por número
                    return numA - numB;
                });
            
                miembros.forEach(miembro => lista_miembros.appendChild(miembro));
            }
        }
    }
}

function loaderMembersForm(){
    const loaderMember = document.querySelector('.cont_loader_miembro');
    if(loaderMember){
        const btn_import = document.querySelector('.form_miembros .import_members');
        btn_import.addEventListener('click',()=>{
            loaderMember.classList.add('loading');
        })

    }
}

function createMemberByForm(){
    const form_create = document.querySelector('.form_miembro_indv.create');

    if(form_create){
        const btn_submit = form_create.querySelector('.btn_submit.agregar');
        const loader = document.querySelector('.panel_acred .cont_loader_miembro');

        btn_submit.addEventListener('click',()=>{

            if(form_create.classList.contains('mostrar')){
                const campos = getCreateFormFields();
                if(campos){
                    loader.classList.add('loading');
                    fetch('/api/createMemberByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  // Parsear la respuesta JSON
                      .then(data => {
                        //   console.log(data);
                          if(data['response'] == 200){
                            insertSuccessful(campos,data['internalId']);
                            loader.classList.remove('loading');
                          }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al agregar miembro');
                            }else{
                                showAlert('error',data['error']);
                            }
                            loader.classList.remove('loading');
                          }
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al agregar miembro');
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function insertSuccessful(campos,intId){
            showAlert('success','Miembro agregado correctamente');
            createNewMemberRow(campos,intId);
            // sortNewMembersList();
            raiseMemberFields();

            // refreshAllMembers();
        }

        function createNewMemberRow(member,intId) {
            const lista_miembros = document.querySelector(".lista_miembros");
            const emptyMessage = lista_miembros.querySelector(".emptyMessage");
            const row = document.createElement("div");
            row.classList.add("row_miembro","activo");
            row.dataset.doc = member.Doc;
            row.dataset.internal = intId;
            row.dataset.nombre = member.Nombre;
            row.dataset.codOrg = member.CodOrg;
            row.dataset.organismo = member.Organismo;
            row.dataset.rama = member.Rama;
            row.dataset.activo = 1;
            row.dataset.asistencia = 0;
        
            row.innerHTML = `
                <div class="campo campo_internal" style="display: none;">
                    <p>${intId}</p>
                </div>
                <div class="campo campo_asistencia" title="Asistencia">
                    <label class="switch attendance_check">
                        <input type="checkbox">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="campo campo_nombre">
                    <p>${member.Nombre}</p>
                </div>
                <div class="campo campo_doc">
                    <p>${member.Doc}</p>
                </div>
                <div class="campo campo_org">
                    <p>${member.CodOrg}-${member.Organismo}</p>
                </div>
                <div class="campo campo_rama ${member.Rama.replace(/\d/g, '').toLowerCase()}" title="${member.NombreRama}">
                    <p>${member.NombreRama}</p>
                </div>
                <div class="campo campo_codrama" style="display: none;">
                    <p>${member.Rama}</p>
                </div>
                <div class="campo campo_req_eventuales" title="Requisitos eventuales">
                    <div class="circulo_requisito incompleto"></div>
                </div>
                <div class="campo campo_req_fijos" title="Requisitos fijos">
                    <div class="circulo_requisito incompleto"></div>
                </div>
            `;
            
            if(emptyMessage){
                emptyMessage.style.display = 'none';
            }
            lista_miembros.appendChild(row);
            applyNominaColumnPreferences(getCurrentNominaPreferenceChecks());
            applyCurrentMemberTableSort(lista_miembros);
            // addEventsButtoms(row);

        }

        function sortNewMembersList(){
            const sort_rama = document.querySelector('.btn_sort.sort_rama');
            const sort_name = document.querySelector('.btn_sort.sort_name');

            if(sort_name.classList.contains('asc')){
                sort_name.classList.remove('asc');
                sort_name.click();
            }
            if(sort_rama.classList.contains('asc')){
                sort_rama.classList.remove('asc');
                sort_rama.click();
            }
        }

        function getCreateFormFields(){
            const campo_doc = form_create.querySelector('.campo.documento input');
            const campo_nombre = form_create.querySelector('.campo.nombre input');
            const campo_cod_org = form_create.querySelector('.campo.cod_org input');
            const campo_org = form_create.querySelector('.campo.org input');
            const campo_rama = form_create.querySelector('.campo.rama select');
            const campo_observacion_manual = form_create.querySelector('#observacion_manual_create');
            const nombre_rama = campo_rama.options[campo_rama.selectedIndex].text;
            // const campo_tel = form_create.querySelector('.campo.telefono input');

            let errorMsg = "Faltó completar ";
            let error = false;
            if(campo_doc.value == ''){
                errorMsg = errorMsg + 'DNI. ';
                error = true
            }
            if(campo_nombre.value == ''){
                errorMsg = errorMsg + 'Nombre. ';
                error = true
            }
            if(campo_cod_org.value == ''){
                errorMsg = errorMsg + 'Nro. Organismo. ';
                error = true
            }
            if(campo_org.value == ''){
                errorMsg = errorMsg + 'Nombre Organismo. ';
                error = true
            }
            if(campo_rama.value == 0){
                errorMsg = errorMsg + 'Rama. ';
                error = true
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
    
            dic = {'Doc':campo_doc.value,'Nombre':campo_nombre.value,
                'Rama':campo_rama.value,'NombreRama':nombre_rama,
                'CodOrg':normalizeOrgCode(campo_cod_org.value),'Organismo':campo_org.value,
                'ObservacionManual':campo_observacion_manual.value.trim(),'NomId':nominaNr};
    
            return dic;
        }

        function raiseMemberFields(){
            const inputNombre = form_create.querySelector("#nombre_create");
            const inputCodOrg = form_create.querySelector("#cod_org_create");
            const inputOrg = form_create.querySelector("#org_create");
            const inputDoc = form_create.querySelector("#documento_create");
            const inputRama = form_create.querySelector("#rama_create");
            const inputObservacionManual = form_create.querySelector("#observacion_manual_create");
            // const inputTelefono = form_create.querySelector("#telefono_create");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_create.classList.remove('mostrar');
            inputNombre.value = '';
            inputCodOrg.value = '';
            inputOrg.value = '';
            inputDoc.value = '';
            inputObservacionManual.value = '';
            // inputTelefono.value = '';
            inputRama.value = 0;
    
        }

        function addEventsButtoms(row){
            const btn_edit = row.querySelector(".editar_miembro");
            const btn_delete = row.querySelector(".eliminar_miembro");
            const formEdit = document.querySelector('.form_miembro_indv.edit');
            const layout = document.querySelector('.layout');
            const formDelete = document.querySelector('.form_miembro_indv.delete');

            btn_edit.addEventListener("click",()=>{
                if(formEdit.classList.contains('mostrar')){
                    formEdit.classList.remove('mostrar');
                    formEdit.classList.add('ocultar');
                    layout.classList.remove('mostrar');
                    row.classList.remove('selected');
                    raiseEditFields();
                }else{
                    formEdit.classList.add('mostrar');
                    formEdit.classList.remove('ocultar'); 
                    layout.classList.add('mostrar');
                    row.classList.add('selected');
                    completeEditFields(row);
                }
            })

            btn_delete.addEventListener("click",()=>{
                if(formDelete.classList.contains('mostrar')){
                    formDelete.classList.remove('mostrar');
                    formDelete.classList.add('ocultar');
                    layout.classList.remove('mostrar');
                    row.classList.remove('selected');
                    raiseDeleteFields();
                }else{
                    formDelete.classList.add('mostrar');
                    formDelete.classList.remove('ocultar'); 
                    layout.classList.add('mostrar');
                    row.classList.add('selected');
                    completeDeleteFields(row);
                }
            })

            function completeEditFields(row){
                const activo = row.querySelector(".campo_activo div");
                const nombre = row.querySelector(".campo_nombre p");
                const doc = row.querySelector(".campo_doc p");
                const rama = row.querySelector(".campo_codrama p");
                // const telefono = row.querySelector(".campo_telefono p");
        
                const inputActivo = formEdit.querySelector("#activo");
                const inputNombre = formEdit.querySelector("#nombre_edit");
                // const inputDoc = formEdit.querySelector("#documento_edit");
                const inputRama = formEdit.querySelector("#rama_edit");
                // const inputTelefono = formEdit.querySelector("#telefono_edit");
                
                inputNombre.value = nombre.innerHTML;
                // inputDoc.value = doc.innerHTML;
                // inputTelefono.value = telefono.innerHTML;
                inputRama.value = rama.innerHTML;
        
                if(activo.classList.contains('activo')){
                    inputActivo.checked = true;
                }else{
                    inputActivo.checked = false;
                }
        
            }
        
            function raiseEditFields(){
                const inputActivo = formEdit.querySelector("#activo");
                const inputNombre = formEdit.querySelector("#nombre_edit");
                // const inputDoc = formEdit.querySelector("#documento_edit");
                const inputRama = formEdit.querySelector("#rama_edit");
                // const inputTelefono = formEdit.querySelector("#telefono_edit");
                
                inputNombre.value = '';
                // inputDoc.value = '';
                // inputTelefono.value = '';
                inputRama.value = 0;
                inputActivo.checked = false;
        
            }

            function completeDeleteFields(row){
                const doc = row.querySelector(".campo_doc p");
                const legend = formDelete.querySelector(".eliminar_miembro legend");
  
                legend.innerHTML += doc.innerHTML + '?';
            }
        
            function raiseDeleteFields(){
                const legend = formDelete.querySelector(".eliminar_miembro legend");
                legend.innerHTML = '¿Eliminar Miembro DNI: ';
            }
        }
    }

}

function editMemberByForm(){
    const form_edit = document.querySelector('.form_miembro_indv.edit');

    if(form_edit){
        const btn_submit = form_edit.querySelector('.btn_submit.editar');
        const loader = document.querySelector('.panel_config.config_miembros .cont_loader_miembro');
        
        btn_submit.addEventListener('click',()=>{

            if(form_edit.classList.contains('mostrar')){
                const campos = getEditFormFields();
                if(campos){
                    loader.classList.add('loading');
                    //console.log(campos);
                    fetch('/api/editMemberByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  //Parsear la respuesta JSON
                      .then(data => {
                        //console.log(data);  //Hacer algo con la respuesta
                        if(data['response'] == 200){
                            updateSuccessful(campos);
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Miembro');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Miembro');
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function updateSuccessful(campos){
            showAlert('success','Miembro actualizado correctamente');
            editMemberRow(campos);
            sortNewMembersList();
            raiseMemberFields();

            refreshAllMembers();
        }

        function editMemberRow(member) {
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
        
            const activo = row.querySelector(".campo_activo div");
            const nombre = row.querySelector(".campo_nombre p");
            const rama = row.querySelector(".campo_codrama p");
            const divRamaNombre = row.querySelector(".campo_rama");
            const ramaNombre = row.querySelector(".campo_rama p");
            // const telefono = row.querySelector(".campo_telefono p");
            
            nombre.innerHTML = member.Nombre;
            // telefono.innerHTML = member.Tel;
            rama.innerHTML = member.Rama;
            ramaNombre.innerHTML = member.NombreRama;
            nombre.title = member.Nombre;

            divRamaNombre.className = '';
            divRamaNombre.classList.add('campo','campo_rama');
            divRamaNombre.classList.add(member.Rama.replace(/\d/g, '').toLowerCase());
            divRamaNombre.title = member.NombreRama;
    
            if(member.Active == true){
                activo.classList.remove('inactivo');
                activo.classList.add('activo');
                row.classList.remove('inactivo');
                row.classList.add('activo');
            }else{
                activo.classList.remove('activo');
                activo.classList.add('inactivo');
                row.classList.remove('activo');
                row.classList.add('inactivo');
            }
        }

        function sortNewMembersList(){
            const sort_rama = document.querySelector('.btn_sort.sort_rama');
            const sort_name = document.querySelector('.btn_sort.sort_name');

            if(sort_name.classList.contains('asc')){
                sort_name.classList.remove('asc');
                sort_name.click();
            }
            if(sort_rama.classList.contains('asc')){
                sort_rama.classList.remove('asc');
                sort_rama.click();
            }
        }

        function getEditFormFields(){
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const intId = row.querySelector(".campo_internal p").innerHTML;
            const campo_nombre = form_edit.querySelector('.campo.nombre input');
            const campo_rama = form_edit.querySelector('.campo.rama select');
            const nombre_rama = campo_rama.options[campo_rama.selectedIndex].text;
            // const campo_tel = form_edit.querySelector('.campo.telefono input');
            const campo_active = form_edit.querySelector('.campo.activo input');

            let errorMsg = "Faltó completar ";
            let error = false;
            if(campo_nombre.value == ''){
                errorMsg = errorMsg + 'Nombre. ';
                error = true
            }
            if(campo_rama.value == 0){
                errorMsg = errorMsg + 'Unidad. ';
                error = true
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
    
            dic = {'Nombre':campo_nombre.value,
                'Rama':campo_rama.value,'NombreRama':nombre_rama,
                'Active':campo_active.checked,'InternalId':intId};
    
            return dic;
        }

        function raiseMemberFields(){
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const inputNombre = form_edit.querySelector("#nombre_edit");
            const inputRama = form_edit.querySelector("#rama_edit");
            // const inputTelefono = form_edit.querySelector("#telefono_edit");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_edit.classList.remove('mostrar');
            row.classList.remove('selected');
            inputNombre.value = '';
            // inputTelefono.value = '';
            inputRama.value = 0;
    
        }
    }
}

function deleteMemberByForm(){
    const form_delete = document.querySelector('.form_miembro_indv.delete');

    if(form_delete){
        const btn_submit = form_delete.querySelector('.btn_submit.eliminar');

        btn_submit.addEventListener('click',()=>{
            
            const loader = document.querySelector('.panel_config.config_miembros .cont_loader_miembro');
            if(form_delete.classList.contains('mostrar')){
                const campos = getDeleteFormFields();
                if(campos){
                    loader.classList.add('loading');
                    //console.log(campos);
                    fetch('/api/deleteMemberByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  //Parsear la respuesta JSON
                      .then(data => {
                          //console.log(data);  //Hacer algo con la respuesta
                          if(data['response'] == 200){
                            deleteSuccessful(campos);
                          }else{
                            console.error('Error en la solicitud:', data['error']);
                            showAlert('error','Error al Eliminar Miembro');
                            raiseMemberFields();
                          }
                          loader.classList.remove('loading');
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Eliminar Miembro');
                        raiseMemberFields();
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function deleteSuccessful(campos){
            showAlert('success','Miembro eliminado correctamente');
            deleteMemberRow(campos);
            raiseMemberFields();

            refreshAllMembers();
        }

        function deleteMemberRow(member) {
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const emptyMessage = lista_miembros.querySelector(".emptyMessage");

            row.remove();

            const rows = lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro)");
            if(rows.length == 0){emptyMessage.style.display = 'block';}
        }

        function getDeleteFormFields(){
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const doc = row.dataset.doc || row.querySelector(".campo_doc p").innerHTML;
    
            dic = {'Doc':doc,'NomId':nominaNr};
    
            return dic;
        }

        function raiseMemberFields(){
            const legend = form_delete.querySelector(".legend_delete");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_delete.classList.remove('mostrar');
            legend.textContent = legend.textContent.split(":")[0] + ":"; 
        }
    }


}

function listenNominaList(){
    const panel_nomina = document.querySelector('.panel_nomina');
    if(panel_nomina){
        const agregar_nomina = panel_nomina.querySelector('.nomina.agregar');
        const nominas = panel_nomina.querySelectorAll('.nomina:not(.agregar)');
        const contenido_nominas = panel_nomina.querySelector('.contenido_nominas');

        agregar_nomina.addEventListener('click', createNomina);

        nominas.forEach((nomina) =>{
            const editar = nomina.querySelector('.lapiz_editar');
            const eliminar = nomina.querySelector('.tacho_borrar');
            const nombreLink = nomina.querySelector('.nombre_left input');
            
            nombreLink.addEventListener("click", openNomina);
            editar.addEventListener('click', editNomina);
            eliminar.addEventListener('click', deleteNomina);
        })

        function openNomina(event) {
            const nombreLink = event.currentTarget;
            const nomina = nombreLink.closest('.nomina');

            const id = nomina.getAttribute('data-id');

            window.open(`nomina.php?id=${id}`, '_blank');
        }

        function createNomina(){
            const checkNew = panel_nomina.querySelector('.nomina.nueva');
            const loader = document.querySelector('.panel_nomina .cont_loader_config');
            if(checkNew){return;}

            const newNomina = document.createElement('DIV');
            const today = todayStr();

            newNomina.classList.add('nomina');
            newNomina.classList.add('nueva');
            newNomina.innerHTML = `
                <div class="cont_nomina">
                    <div class="nombre_nomina">
                        <div class="nombre_left">
                            <input class="nomina_card_title" type="text" value="">
                        </div>
                        <div class="nombre_right">
                            <div class="tilde_guardar">
                                <i class="fa-solid fa-check fa-xl" style="color: #4b1a5a;"></i>
                            </div>
                            <div class="cruz_cancelar">
                                <i class="fa-solid fa-xmark fa-xl" style="color: #4b1a5a;"></i>
                            </div>
                        </div>
                    </div>
                    <div class="info_nomina">
                        <div class="fecha_nomina">
                            <i class="fa-regular fa-calendar-days"></i>
                            <p>${today}</p>
                        </div>
                        <div class="miembros_nomina">
                            <div class="icono_miembros">
                                <i class="fa-solid fa-user-group"></i>
                            </div>
                            <div class="cant_miembros">
                                <p>0</p>
                            </div>
                        </div>
                    </div>
                </div>
            `

            contenido_nominas.insertBefore(newNomina, agregar_nomina);

            const guardar = newNomina.querySelector('.tilde_guardar');
            const cancelar = newNomina.querySelector('.cruz_cancelar');
            const nombre = newNomina.querySelector('.nombre_left input');

            cancelar.addEventListener('click', () => cancelNomina(newNomina));
            guardar.addEventListener('click', async () => await saveNomina(newNomina));
            nombre.focus();

            async function saveNomina(nomina){

                const dataAPI = getNominaData(nomina);
                if(!dataAPI){return;}
                const successSave = await saveNominaAPI(dataAPI);

                if(successSave){
                    successSaveNomina(successSave);
                }

                function getNominaData(nomina){
                    const data = {};
                    const nombre = nomina.querySelector('.nombre_left input');

                    if(!nombre.value || nombre.value == ''){
                        showAlert('error','Debés ponerle un nombre a la nómina');
                        return false;
                    }
                    data['Nombre'] = nombre.value;

                    return data;
                }

                async function saveNominaAPI(data){
                    loader.classList.add('loading');
                    return fetch('/api/createNomina.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                                loader.classList.remove('loading');
                                showAlert('success','Nómina creada correctamente');
                                return data['nominaId'];
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al crear nómina');
                                }else{
                                    showAlert('error',data['error']);
                                }
                                return false;
                                //raiseMemberFields();
                            }
                            loader.classList.remove('loading');
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al crear nómina');
                            //raiseMemberFields();
                            loader.classList.remove('loading');
                            return false;
                    });
                }

                function successSaveNomina(nomId){
                    const nombre = nomina.querySelector('.nombre_left input');
                    const nombre_right = nomina.querySelector('.nombre_right');
                    const guardar = nomina.querySelector('.tilde_guardar');
                    const cancelar = nomina.querySelector('.cruz_cancelar');
                    const editar = document.createElement('DIV');
                    const eliminar = document.createElement('DIV');
                
                    nombre.readOnly = true;
                    nomina.setAttribute('data-id',nomId);
                    nomina.classList.remove('nueva'); 
                    nombre.title = nombre.value || 'Nómina';
                    const nombreLeft = nombre.closest('.nombre_left');
                    if(nombreLeft){nombreLeft.classList.remove('editing');}
                    
                    guardar.remove();
                    cancelar.remove();

                    editar.classList.add('lapiz_editar');
                    editar.innerHTML = '<i class="fa-solid fa-pen" style="color: #4b1a5a;"></i>';

                    eliminar.classList.add('tacho_borrar');
                    eliminar.innerHTML = '<i class="fa-solid fa-trash" style="color: #4b1a5a;"></i>';

                    nombre_right.appendChild(editar);
                    nombre_right.appendChild(eliminar);

                    nombre.addEventListener("click", openNomina);
                    editar.addEventListener('click', editNomina);
                    eliminar.addEventListener('click', deleteNomina);
                    initNominaTitleMarquee();
                }
            }
        }

        function editNomina(event){

            const edit = event.currentTarget;
            const nomina = edit.closest('.nomina');
            const id = nomina.getAttribute('data-id');
            const nombre_right = nomina.querySelector('.nombre_right');
            const nombreViejo = nomina.querySelector('.nombre_left input').value;
            const loader = document.querySelector('.panel_nomina .cont_loader_config');

            nombre_right.innerHTML = `
                <div class="tilde_guardar">
                    <i class="fa-solid fa-check fa-xl" style="color: #4b1a5a;"></i>
                </div>
                <div class="cruz_cancelar">
                    <i class="fa-solid fa-xmark fa-xl" style="color: #4b1a5a;"></i>
                </div>
            `

            const guardar = nomina.querySelector('.tilde_guardar');
            const cancelar = nomina.querySelector('.cruz_cancelar');
            const nombre = nomina.querySelector('.nombre_left');
            const nombreInput = nombre.querySelector('input');

            cancelar.addEventListener('click', () => backToReadOnly(nomina,true));
            guardar.addEventListener('click', async () => await saveEditNomina(nomina));

            nombre.classList.add('editing');
            nombre.classList.remove('scrollable');
            nombre.style.removeProperty('--nomina-title-distance');
            nombreInput.style.removeProperty('width');
            nombreInput.readOnly = false;
            nombreInput.focus();
            nombreInput.removeEventListener("click", openNomina);

            function backToReadOnly(nomina,cancel = false){
                const nombre = nomina.querySelector('.nombre_left input');
                const nombre_right = nomina.querySelector('.nombre_right');
                const guardar = nomina.querySelector('.tilde_guardar');
                const cancelar = nomina.querySelector('.cruz_cancelar');
                const editar = document.createElement('DIV');
                const eliminar = document.createElement('DIV');
            
                nombre.readOnly = true;
                if(cancel){
                    nombre.value = nombreViejo;
                }
                nombre.title = nombre.value || 'Abrir nómina';
                const nombreLeft = nombre.closest('.nombre_left');
                if(nombreLeft){nombreLeft.classList.remove('editing');}
                
                guardar.remove();
                cancelar.remove();

                editar.classList.add('lapiz_editar');
                editar.innerHTML = '<i class="fa-solid fa-pen" style="color: #4b1a5a;"></i>';

                eliminar.classList.add('tacho_borrar');
                eliminar.innerHTML = '<i class="fa-solid fa-trash" style="color: #4b1a5a;"></i>';

                nombre_right.appendChild(editar);
                nombre_right.appendChild(eliminar);

                nombre.addEventListener("click", openNomina);
                editar.addEventListener('click', editNomina);
                eliminar.addEventListener('click', deleteNomina);
                initNominaTitleMarquee();
            }

            async function saveEditNomina(nomina){

                const dataAPI = getNominaData(nomina);
                if(!dataAPI){return;}
                const successSave = await saveNominaAPI(dataAPI);

                if(successSave){
                    backToReadOnly(nomina);
                }

                function getNominaData(nomina){
                    const data = {};
                    const nombre = nomina.querySelector('.nombre_left input');
                    const id = nomina.getAttribute('data-id');

                    if(!nombre.value || nombre.value == ''){
                        showAlert('error','Debés ponerle un nombre a la nómina');
                        return false;
                    }
                    if(!id || id == ''){
                        showAlert('error','La nómina debe tener un id');
                        return false;
                    }

                    data['Nombre'] = nombre.value;
                    data['IntId'] = id;

                    return data;
                }

                async function saveNominaAPI(data){
                    loader.classList.add('loading');
                    return fetch('/api/editNomina.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                                loader.classList.remove('loading');
                                showAlert('success','Nómina actualizada correctamente');
                                return true;
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al actualizar nómina');
                                }else{
                                    showAlert('error',data['error']);
                                }
                                return false;
                                //raiseMemberFields();
                            }
                            loader.classList.remove('loading');
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al actualizar nómina');
                            //raiseMemberFields();
                            loader.classList.remove('loading');
                            return false;
                    });
                }

            }
        }

        async function deleteNomina(event){

            const edit = event.currentTarget;
            const nomina = edit.closest('.nomina');
            const id = nomina.getAttribute('data-id');
            const dataAPI = getNominaData(nomina);
            const loader = document.querySelector('.panel_nomina .cont_loader_config');

            if(!dataAPI){return;}
            const successSave = await saveNominaAPI(dataAPI);

            if(successSave){
                cancelNomina(nomina);
            }

            function getNominaData(nomina){
                const data = {};
                const id = nomina.getAttribute('data-id');

                if(!id || id == ''){
                    showAlert('error','La nómina debe tener un id');
                    return false;
                }

                data['IntId'] = id;

                return data;
            }

            async function saveNominaAPI(data){
                loader.classList.add('loading');
                return fetch('/api/deleteNomina.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            loader.classList.remove('loading');
                            showAlert('success','Nómina eliminada correctamente');
                            return true;
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al eliminar nómina');
                            }else{
                                showAlert('error',data['error']);
                            }
                            return false;
                            //raiseMemberFields();
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al eliminar nómina');
                        //raiseMemberFields();
                        loader.classList.remove('loading');
                        return false;
                });
            }

        }

        function cancelNomina(nomina){
            nomina.remove();
        }

    }
}

function listenNominaEstadoFilter(){
    const contenido_nominas = document.querySelector('.contenido_nominas');
    const filtro = document.querySelector('.filtro_nominas');
    if(!contenido_nominas || !filtro){return;}

    const opciones = filtro.querySelectorAll('.opciones');
    const nominas = contenido_nominas.querySelectorAll('.nomina[data-finalizada]');
    const agregar = contenido_nominas.querySelector('.nomina.agregar');
    const estadoGuardado = localStorage.getItem('nominaEstadoFiltro') === 'finalizado' ? 'finalizado' : 'activo';

    aplicarFiltro(estadoGuardado);

    opciones.forEach(opcion => {
        opcion.addEventListener('click', () => {
            if(opcion.classList.contains('activado')){return;}

            aplicarFiltro(opcion.dataset.estado);
        });
    });

    function aplicarFiltro(estado){
        opciones.forEach(o => o.classList.toggle('activado',o.dataset.estado === estado));

        nominas.forEach(nomina => {
            const esFinalizada = nomina.dataset.finalizada === '1';
            const mostrar = estado === 'finalizado' ? esFinalizada : !esFinalizada;
            nomina.style.display = mostrar ? '' : 'none';
        });

        if(agregar){
            agregar.style.display = estado === 'finalizado' ? 'none' : '';
        }

        localStorage.setItem('nominaEstadoFiltro',estado);
    }
}

function manageNominaFinalizeAction(){
    const section = document.querySelector('.config_estado');
    if(!section){return;}

    const btn = section.querySelector('.btn_finalizar_nomina');
    const confirmBox = section.querySelector('.finalizar_nomina_confirm');
    const btnYes = section.querySelector('.confirm_finalizar_yes');
    const btnNo = section.querySelector('.confirm_finalizar_no');
    const loader = section.querySelector('.cont_loader');
    if(!btn || !confirmBox || !btnYes || !btnNo){return;}

    btn.addEventListener('click', () => {
        confirmBox.classList.add('mostrar');
    });

    btnNo.addEventListener('click', () => {
        confirmBox.classList.remove('mostrar');
    });

    btnYes.addEventListener('click', async () => {
        if(loader){loader.classList.add('loading');}

        try {
            const response = await fetch('/api/finalizeNomina.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({'IntId':nominaNr})
            });
            const data = await response.json();

            if(data['response'] == 200){
                showAlert('success','Nómina finalizada correctamente');
                setTimeout(() => location.reload(), 600);
                return;
            }

            showAlert('error',data['error'] || 'Error al finalizar nómina');
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al finalizar nómina');
        }

        if(loader){loader.classList.remove('loading');}
    });
}

function createRamaInTable(){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont)=>{
            const btn_create = cont.querySelector('.crear_uni');
            const addBtn = cont.querySelector('.agregar_unidad');
            const input = addBtn.querySelector('input');
            const loader = document.querySelector('.panel_config .cont_unidades .cont_loader');
            btn_create.addEventListener('click',()=>{
                if(addBtn.classList.contains('input')){
                    if(input.value.trim() != ''){
                        loader.classList.add('loading');
                        campos = {'Rama':btn_create.id,'Nombre':input.value}
                        // console.log(campos);
                        fetch('/api/createRama.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(campos)
                            })
                            .then(response => response.json())
                            .then(data => {
                                // console.log(data);
                                if(data['response'] == 200){
                                    createSuccess(campos,data['codRama'],cont);
                                }else{
                                    console.error('Error en la solicitud:', data['error']);
                                    if(Object.keys(data['error']).length === 0){
                                        showAlert('error','Error al Crear Unidad');
                                    }else{
                                        showAlert('error',data['error']);
                                    }
                                    //raiseMemberFields();
                                }
                                loader.classList.remove('loading');
                            })
                            .catch(error => {
                                console.error('Error en la solicitud:', error);
                                showAlert('error','Error al Crear Unidad');
                                //raiseMemberFields();
                                loader.classList.remove('loading');
                            });
                    }else{
                        showAlert('error','Debés ponerle un nombre a la unidad');
                        addBtn.classList.add('input');
                    }
                }
            })
        })

        function createSuccess(campos,cod,cont){
            showAlert('success','Unidad creada correctamente');
            clearFields();
            createRamaRow(campos,cod,cont);

            refreshRamas();
        }

        function clearFields(){
            cont_ramas.forEach((cont)=>{
                const addBtn = cont.querySelector('.agregar_unidad');
                const input = addBtn.querySelector('input');
                input.value = '';
                addBtn.classList.remove('input');
            })
        }

        function createRamaRow(campos,cod,cont){
            const row = document.createElement("div");
            const lista_unidades = cont.querySelector(".lista_unidades");
            const agregarUnidad = lista_unidades.querySelector(".agregar_unidad");
            const rows = lista_unidades.querySelectorAll('.unidad');

            row.id = cod;
            row.classList.add("unidad","row","new");
            row.innerHTML = `
            <p>${campos.Nombre}</p>
            <div class="acciones_unidad">
                <i class="fa-solid fa-square-pen edit fa-xl" style="color: #0071bc;"></i>
                <i class="fa-solid fa-square-xmark delete fa-xl" style="color: #ad272d;"></i>
            </div>
            `;

            if(rows.length == 1){
                lista_unidades.classList.remove('fullheight');
            }

            lista_unidades.insertBefore(row, agregarUnidad);
            showRamasActions(true);
            editRamaInTable(true);
            deleteRamaInTable(true);
        }

    }
}

function editRamaInTable(newRow = false){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont)=>{

            let all_row_rama = [];
            if(newRow){
                all_row_rama = cont.querySelectorAll('.unidad.row.new');
            }else{
                all_row_rama = cont.querySelectorAll('.unidad.row');
            }

            all_row_rama.forEach((rowRama)=>{
                const btn_edit = rowRama.querySelector('.acciones_unidad .edit');
                const pRama = rowRama.querySelector('p');

                btn_edit.addEventListener('click',()=>{
                    convertirAInput(pRama,rowRama);
                    const checkEdit = rowRama.querySelector('i.editar_uni');
                    if (checkEdit){
                        const input = rowRama.querySelector('.input_edit');
                        const loader = document.querySelector('.panel_config .cont_unidades .cont_loader');
                        checkEdit.addEventListener('click',()=>{
                            if(input.value.trim() != ''){
                                loader.classList.add('loading');
                                campos = {'CodRama':rowRama.id,'Nombre':input.value}
                                // console.log(campos);
                                fetch('/api/editRama.php', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(campos)
                                    })
                                    .then(response => response.json())
                                    .then(data => {
                                        // console.log(data);
                                        if(data['response'] == 200){
                                        editSuccess(campos,rowRama,pRama);
                                        }else{
                                            console.error('Error en la solicitud:', data['error']);
                                            if(Object.keys(data['error']).length === 0){
                                                showAlert('error','Error al Actualizar Unidad');
                                            }else{
                                                showAlert('error',data['error']);
                                            }
                                            //raiseMemberFields();
                                        }
                                        loader.classList.remove('loading');
                                    })
                                    .catch(error => {
                                        console.error('Error en la solicitud:', error);
                                        showAlert('error','Error al Actualizar Unidad');
                                        //raiseMemberFields();
                                        loader.classList.remove('loading');
                                    });
                            
                            }else{
                                showAlert('error','Debes Ponerle un nombre a la Unidad');
                            }
                        })
                    }
                })
            })
        })

        function convertirAInput(p,rowRama) {
            const actions = rowRama.querySelector(".acciones_unidad");
            let valorActual = p.innerText; // Guarda el texto actual
            let input = document.createElement("input");
            let check = document.createElement("i");

            rowRama.classList.add('input_edit');
            actions.classList.remove('showActions');

            input.type = "text";
            input.classList.add('input_edit');
            input.value = valorActual;
            //input.onblur = function() { revertirAParrafo(input,p,rowRama); };

            check.classList.add('fa-solid','fa-circle-check','editar_uni')
            
            rowRama.appendChild(check);
            p.replaceWith(input);
            input.focus();

            document.addEventListener("click", (event) => {
                // Si el clic no es dentro de una fila ni dentro de .acciones_unidad
                if (!event.target.closest(".unidad.row") && !event.target.closest(".input_edit")) {
                    revertirAParrafo(input,p,rowRama); // Cierra las acciones
                }
            });

            function revertirAParrafo(input,p,rowRama) {
                rowRama.classList.remove('input_edit');
                showRamasActions();
                input.replaceWith(p);
                check.remove();
            }
        }

        function editSuccess(campos,rowRama,pRama){
            showAlert('success','Unidad actualizada correctamente');
            clearFields(rowRama,pRama);
            editRamaRow(campos,rowRama);

            refreshRamas();
        }

        function clearFields(rowRama,p){
            const check = rowRama.querySelector('i.editar_uni');
            const input = rowRama.querySelector('.input_edit');
            rowRama.classList.remove('input_edit');
            showRamasActions();
            input.replaceWith(p);
            check.remove();
        }

        function editRamaRow(campos,rowRama){
            const row = rowRama.querySelector("p");
            row.innerHTML = campos['Nombre'];
        }

    }
}

function deleteRamaInTable(newRow = false){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont)=>{

            let all_row_rama = [];
            if(newRow){
                all_row_rama = cont.querySelectorAll('.unidad.row.new');
            }else{
                all_row_rama = cont.querySelectorAll('.unidad.row');
            }

            all_row_rama.forEach((rowRama)=>{
                const btn_delete = rowRama.querySelector('.acciones_unidad .delete');
                const loader = document.querySelector('.panel_config .cont_unidades .cont_loader');

                rowRama.classList.remove('new');
                btn_delete.addEventListener('click',()=>{
                    loader.classList.add('loading');
                    campos = {'CodRama':rowRama.id}
                    // console.log(campos);
                    fetch('/api/deleteRama.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                            deleteSuccess(rowRama);
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Eliminar Unidad');
                                }else{
                                    showAlert('error',data['error']);
                                }
                            //raiseMemberFields();
                            }
                            loader.classList.remove('loading');
                        })
                            .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Eliminar Unidad');
                            //raiseMemberFields();
                            loader.classList.remove('loading');
                        });
                })
            })
        })

        function deleteSuccess(rowRama){
            showAlert('success','Unidad eliminada correctamente');
            deleteRamaRow(rowRama);
        }

        function deleteRamaRow(rowRama){
            const listaUnidades = rowRama.parentElement;
            const rows = listaUnidades.querySelectorAll('.unidad');

            if(rows.length > 0){listaUnidades.classList.add('fullheight')}
            rowRama.remove();
            refreshRamas();
        }

    }
}

function showRamasActions(newRow = false){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            const lista_unidades = cont.querySelector(".lista_unidades");

            let unidades = [];
            if(newRow){
                unidades = cont.querySelectorAll('.unidad.row.new');
            }else{
                unidades = cont.querySelectorAll('.unidad.row');
            }

            unidades.forEach((unidad)=>{
                const actions = unidad.querySelector(".acciones_unidad");

                unidad.addEventListener('click',(event)=>{
                    event.stopPropagation();
                    removeAllActions();
                    if(!unidad.classList.contains('input_edit')){
                        actions.classList.add('showActions');
                    }
                })
            })
        })

        function removeAllActions(){
            cont_ramas.forEach((cont) => {
                const lista_unidades = cont.querySelector(".lista_unidades");
                const unidades = lista_unidades.querySelectorAll(".unidad.row");
                unidades.forEach((unidad)=>{
                    const actions = unidad.querySelector(".acciones_unidad");
                    actions.classList.remove('showActions');
                })
            })
    
        }

        document.addEventListener("click", (event) => {
            // Si el clic no es dentro de una fila ni dentro de .acciones_unidad
            if (!event.target.closest(".unidad.row") && !event.target.closest(".acciones_unidad")) {
                removeAllActions(); // Cierra las acciones
            }
        });
    }
}

function addRamaSettingForm(){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            const addBtn = cont.querySelector('.agregar_unidad');
        
            addBtn.addEventListener('click', (event) => {
                removeAllAddBtn();
                if (!addBtn.classList.contains('input')) {
                    addBtn.classList.add('input');
                    const input = addBtn.querySelector('input');
                    input.focus();
                }
                event.stopPropagation(); // Evita que el click se propague al document
            });

            document.addEventListener('click', (event) => {
                if (!cont.contains(event.target)) {
                    const addBtn = cont.querySelector('.agregar_unidad');
                    if (addBtn.classList.contains('input')) {
                        addBtn.classList.remove('input');
                    }
                }
            });
        });

        function removeAllAddBtn(){
            cont_ramas.forEach((cont) => {
                const addBtn = cont.querySelector('.agregar_unidad');
                addBtn.classList.remove('input');
            })
        }
        
    }
}

function createSignerInTable(){
    const cont_signer = document.querySelector(".contenido_firmas");
    if(cont_signer){
        const cont_agregar = cont_signer.querySelector(".firma_config.agregar");
        const agregar_signer = cont_signer.querySelector(".agregar_firma");
        const firmas = cont_signer.querySelectorAll(".firma_config");
        let creation = false;

        firmas.forEach((signer) => {
            activeSignerAction(signer);
        })

        agregar_signer.addEventListener('click',() => {
            if(!creation){
                creation = true;
                newSigner = createNewSigner();
                cont_signer.insertBefore(newSigner, cont_agregar);
                const nombreInput = newSigner.querySelector(".firma_nombre input");
                const confirmCateg = newSigner.querySelector(".confirmar_signer");
                const anularCreacion = newSigner.querySelector(".anular_creacion");

                nombreInput.focus();

                const loader = document.querySelector('.panel_config .cont_firmantes .cont_loader');

                confirmCateg.addEventListener('click',() => {
                    if(nombreInput.value){
                        loader.classList.add('loading');
                        campos = {'Nombre':nombreInput.value}
                        // console.log(campos);
                        fetch('/api/createSignatory.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(campos)
                            })
                            .then(response => response.json())
                            .then(data => {
                                // console.log(data);
                                if(data['response'] == 200){
                                    successCreation(newSigner,data['intId']);
                                    showAlert('success',"Firmante creado correctamente")
                                }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Crear Firmante');
                                }else{
                                    showAlert('error',data['error']);
                                }
                                //raiseMemberFields();
                                }
                                loader.classList.remove('loading');
                            })
                            .catch(error => {
                                console.error('Error en la solicitud:', error);
                                showAlert('error','Error al Crear Firmante');
                                //raiseMemberFields();
                                loader.classList.remove('loading');
                            });
                    }else{
                        showAlert('error','Debes completar Nombre');
                    }
                })

                anularCreacion.addEventListener('click',() => {
                    newSigner.remove();
                    creation = false;
                })

            }

        })

        function successCreation(signer,intId){
            const nombreInput = signer.querySelector(".firma_nombre input");
            const accionesSigner = signer.querySelector(".firma_accion");
            const confirmSigner = signer.querySelector(".confirmar_signer");
            const anularCreacion = signer.querySelector(".anular_creacion");

            creation = false;
            signer.setAttribute('data-id', intId);
            
            const p = document.createElement('p');
            p.textContent = nombreInput.value;
            nombreInput.replaceWith(p);

            confirmSigner.remove();
            anularCreacion.remove();

            const eliminar = document.createElement('div');
            eliminar.className = 'campo eliminar_firma';
            eliminar.title = 'Eliminar Firma';
            eliminar.innerHTML = `<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>`;

            accionesSigner.appendChild(eliminar);

            activeSignerAction(signer);

            refreshSignatories();
        }

    }
}

function createNewSigner() {

    const signer = document.createElement('div');
    signer.className = 'firma_config';

    const infoSigner = document.createElement('div');
    infoSigner.className = 'cont_firma';

    const nombreSigner = document.createElement('div');
    nombreSigner.className = 'firma_nombre';

    const inputNombre = document.createElement('input');
    inputNombre.type = 'text';
    inputNombre.name = `nombre_creado`;
    inputNombre.id = `nombre_creado`;

    nombreSigner.appendChild(inputNombre);

    const accionesSigner = document.createElement('div');
    accionesSigner.className = 'firma_accion';

    const confirmar = document.createElement('div');
    confirmar.className = 'campo confirmar_signer';
    confirmar.title = 'Confirmar Firmante';
    confirmar.innerHTML = '<i class="fa-solid fa-square-check fa-xl" style="color:rgb(21, 134, 59);"></i>';

    const anular = document.createElement('div');
    anular.className = 'campo anular_creacion';
    anular.title = 'Anular Creacion';
    anular.innerHTML = '<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>';

    accionesSigner.appendChild(confirmar);
    accionesSigner.appendChild(anular);

    infoSigner.appendChild(nombreSigner);
    infoSigner.appendChild(accionesSigner);

    signer.appendChild(infoSigner);

    return signer;
}

function activeSignerAction(signer) {

    const eliminar = signer.querySelector('.eliminar_firma');

    if (eliminar) {
        eliminar.addEventListener('click', () => {
            deleteSigner(signer);
        });
    }
}

function deleteSigner(signer) {
    const loader = document.querySelector('.panel_config .cont_firmantes .cont_loader');
    loader.classList.add('loading');
    const intId = signer.getAttribute('data-id');
    campos = {'IntId':intId}
    // console.log(campos);
    fetch('/api/deleteSignatory.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(campos)
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                successDelete(signer);
                    showAlert('success',"Firmante eliminado correctamente")
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    showAlert('error','Error al Eliminar Firmante');
                }else{
                    showAlert('error',data['error']);
                }
            }
            loader.classList.remove('loading');
        })
        .catch(error => {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Eliminar Firmante');
            loader.classList.remove('loading');
    });

    function successDelete(signer){
        signer.remove();

        refreshSignatories();
    }
}

function saveNominaPreference(){
    const config_panel = document.querySelector('.panel_acred.acred_config');
    if(config_panel){
        const inputsCheck = config_panel.querySelectorAll('.input_columna input');
        const btn_submit = config_panel.querySelector('.config_info .cont_submit .btn_submit');
        let oldValues = getNominaPreferenceFormData(inputsCheck);
        
        inputsCheck.forEach((input) => {
            input.addEventListener('change', () => {
                applyNominaColumnPreferences(getNominaPreferenceFormData(inputsCheck));
            });
        });
        
        btn_submit.addEventListener('click',() => {
            let changeInfo = false;
            const newValues = getNominaPreferenceFormData(inputsCheck);

            inputsCheck.forEach((input) => {
                if(oldValues[input.id] != newValues[input.id]){
                    changeInfo = true;
                }
            })

            const loader = document.querySelector('.acred_config .config_info .cont_loader');
            if(!changeInfo){
                showAlert('error','No hay cambios en los datos');
            }else{
                loader.classList.add('loading');
                const data = {...newValues, 'NominaNr': nominaNr};
                fetch('/api/saveNominaPreference.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            loader.classList.remove('loading');
                            showAlert('success','Datos guardados correctamente');
                            successSave(newValues);
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                loader.classList.remove('loading');
                                showAlert('error','Error al Guardar Datos');
                            }else{
                                loader.classList.remove('loading');
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        // console.log(error);
                        loader.classList.remove('loading');
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Guardar Datos');
                        loader.classList.remove('loading');
                });
            }
        })

        function successSave(newValues){
            oldValues = {...newValues};
            applyNominaColumnPreferences(newValues);
        }

    }
}

function manageNominaRequirementsConfig(){
    const config = document.querySelector('.config_requisitos');
    if(!config){return;}

    const content = config.querySelector('.contenido_requisitos');
    const addButton = config.querySelector('.requisito_config.agregar');
    const loader = config.querySelector('.cont_loader');
    if(!content || !addButton){return;}

    content.querySelectorAll('.requisito_config:not(.agregar)').forEach(row => {
        attachRequirementActions(row);
    });

    addButton.addEventListener('click', () => {
        if(content.querySelector('.requisito_config.creando')){return;}

        const row = createRequirementRow('', '', true);
        content.insertBefore(row, addButton);
        setRequirementEditMode(row, true);
        row.querySelector('.requisito_nombre input').focus();
    });

    function createRequirementRow(id,name,isNew = false){
        const row = document.createElement('div');
        row.classList.add('requisito_config');
        if(isNew){row.classList.add('creando');}
        if(id){row.dataset.id = id;}

        row.innerHTML = `
            <div class="cont_requisito">
                <div class="requisito_nombre">
                    <p></p>
                </div>
                <div class="requisito_accion">
                    <div class="campo editar_requisito" title="Editar Requisito"><i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i></div>
                    <div class="campo eliminar_requisito" title="Eliminar Requisito"><i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i></div>
                </div>
            </div>
        `;
        row.querySelector('.requisito_nombre p').textContent = name;
        attachRequirementActions(row);

        return row;
    }

    function attachRequirementActions(row){
        const edit = row.querySelector('.editar_requisito');
        const remove = row.querySelector('.eliminar_requisito');

        if(edit){
            edit.addEventListener('click', () => setRequirementEditMode(row, false));
        }
        if(remove){
            remove.addEventListener('click', () => setRequirementDeleteMode(row));
        }
    }

    function setRequirementEditMode(row,isNew){
        const nameContainer = row.querySelector('.requisito_nombre');
        const currentName = nameContainer.querySelector('p') ? nameContainer.querySelector('p').textContent : '';
        nameContainer.innerHTML = `<input type="text" value="">`;
        const input = nameContainer.querySelector('input');
        input.value = currentName;

        setRequirementConfirmActions(row, async () => {
            const name = input.value.trim();
            if(!name){
                showAlert('error','Debes completar el nombre del requisito');
                return;
            }

            const success = isNew ? await createRequirement(name,row) : await updateRequirement(name,row);
            if(success){
                row.classList.remove('creando');
                renderRequirementReadMode(row,name);
                markEventualRequirementSummaryPending();
                showAlert('success', isNew ? 'Requisito creado correctamente' : 'Requisito actualizado correctamente');
            }
        }, () => {
            if(isNew){
                row.remove();
            }else{
                renderRequirementReadMode(row,currentName);
            }
        });

        input.addEventListener('keydown', (event) => {
            if(event.key === 'Enter'){
                row.querySelector('.confirmar_requisito').click();
            }
            if(event.key === 'Escape'){
                row.querySelector('.cancelar_requisito').click();
            }
        });
    }

    function setRequirementDeleteMode(row){
        setRequirementConfirmActions(row, async () => {
            const success = await deleteRequirement(row);
            if(success){
                row.remove();
                markEventualRequirementSummaryPending();
                showAlert('success','Requisito eliminado correctamente');
            }
        }, () => renderRequirementReadMode(row,getRequirementName(row)));
    }

    function setRequirementConfirmActions(row,onConfirm,onCancel){
        const actions = row.querySelector('.requisito_accion');
        actions.innerHTML = `
            <div class="campo confirmar_requisito" title="Confirmar"><i class="fa-solid fa-check fa-xl" style="color: #287a35;"></i></div>
            <div class="campo cancelar_requisito" title="Cancelar"><i class="fa-solid fa-xmark fa-xl" style="color: #ad272d;"></i></div>
        `;
        actions.querySelector('.confirmar_requisito').addEventListener('click', onConfirm);
        actions.querySelector('.cancelar_requisito').addEventListener('click', onCancel);
    }

    function renderRequirementReadMode(row,name){
        row.querySelector('.requisito_nombre').innerHTML = '<p></p>';
        row.querySelector('.requisito_nombre p').textContent = name;
        row.querySelector('.requisito_accion').innerHTML = `
            <div class="campo editar_requisito" title="Editar Requisito"><i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i></div>
            <div class="campo eliminar_requisito" title="Eliminar Requisito"><i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i></div>
        `;
        attachRequirementActions(row);
    }

    function getRequirementName(row){
        const input = row.querySelector('.requisito_nombre input');
        const text = row.querySelector('.requisito_nombre p');
        return input ? input.value : (text ? text.textContent : '');
    }

    async function createRequirement(name,row){
        const data = await saveRequirement('/api/createRequirement.php', {'Nombre':name,'NomId':nominaNr});
        if(data && data['response'] == 200){
            row.dataset.id = data['internalId'];
            return true;
        }
        return false;
    }

    async function updateRequirement(name,row){
        const data = await saveRequirement('/api/editRequirement.php', {'Nombre':name,'InternalId':row.dataset.id,'NomId':nominaNr});
        return data && data['response'] == 200;
    }

    async function deleteRequirement(row){
        const data = await saveRequirement('/api/deleteRequirement.php', {'InternalId':row.dataset.id,'NomId':nominaNr});
        return data && data['response'] == 200;
    }

    async function saveRequirement(url,payload){
        if(config.dataset.saving === '1'){
            return false;
        }

        config.dataset.saving = '1';
        if(loader){loader.classList.add('loading');}

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if(data['response'] != 200){
                showAlert('error',data['error'] || 'Error al guardar requisito');
            }
            return data;
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al guardar requisito');
            return false;
        } finally {
            delete config.dataset.saving;
            if(loader){loader.classList.remove('loading');}
        }
    }

    function markEventualRequirementSummaryPending(){
        document.querySelectorAll('.lista_miembros .campo_req_eventuales .circulo_requisito').forEach(circle => {
            circle.classList.remove('completo');
            circle.classList.add('incompleto');
        });
    }
}

function listenGeneralSettings(){
    const panel = document.querySelector('.general_settings_panel');
    if(!panel){return;}

    const openButton = document.querySelector('.btn_general_settings');
    const closeButton = panel.querySelector('.btn_back_nominas');
    const nominaPanel = document.querySelector('.paneles_nomina');
    const layout = document.querySelector('.layout');
    const loader = panel.querySelector('.general_settings_loader');
    const table = panel.querySelector('.general_members_table');
    const memberModal = document.querySelector('.form_miembro_indv.general_member_detail');
    const addMemberButton = panel.querySelector('.general_add_member');
    const searchInput = panel.querySelector('.general_search input');
    const importForm = panel.querySelector('.general_import_members');
    const importInput = panel.querySelector('.general_import_input');
    const fileButton = panel.querySelector('.general_file_button');
    const fixedReqTable = panel.querySelector('.general_fixed_requirements_table');
    const addFixedReqButton = panel.querySelector('.general_add_fixed_req');
    const activeIndexPanelKey = 'indexPanelActivo';
    let selectedRow = null;
    let initialState = null;

    if(openButton){
        openButton.addEventListener('click', () => openPanel(true));
    }
    if(closeButton){
        closeButton.addEventListener('click', () => closePanel(true));
    }
    if(layout){
        layout.addEventListener('click', () => {
            if(memberModal && memberModal.classList.contains('mostrar')){closeMemberModal();}
        });
    }
    if(fileButton && importInput){
        fileButton.addEventListener('click', () => importInput.click());
        importInput.addEventListener('change', () => {
            if(importInput.files.length > 0){
                const fileName = importInput.files[0].name;
                const label = fileButton.querySelector('p');
                fileButton.title = fileName;
                if(label){label.textContent = fileName;}
            }
        });
    }
    if(importForm){
        importForm.addEventListener('submit', () => {});
    }
    if(searchInput && table){
        searchInput.addEventListener('input', () => filterGlobalMembers(searchInput.value));
    }
    if(addMemberButton){
        addMemberButton.addEventListener('click', () => openMemberModalForCreate());
    }
    if(table){
        table.addEventListener('click', async (event) => {
            const nombre = event.target.closest('.campo_nombre');
            const row = event.target.closest('.row_miembro:not(.header_miembro)');
            if(!nombre || !row){return;}
            await openMemberModalForEdit(row);
        });
    }
    if(memberModal){
        memberModal.querySelector('.btn_x').addEventListener('click', closeMemberModal);
        memberModal.querySelector('.btn_submit.guardar').addEventListener('click', saveGlobalMember);
        memberModal.querySelector('.btn_submit.eliminar').addEventListener('click', () => {
            if(!selectedRow){return;}
            memberModal.querySelector('.detail_delete_confirm').classList.add('mostrar');
        });
        memberModal.querySelector('.confirm_delete_no').addEventListener('click', () => {
            memberModal.querySelector('.detail_delete_confirm').classList.remove('mostrar');
        });
        memberModal.querySelector('.confirm_delete_yes').addEventListener('click', deleteGlobalMember);
        applyOrgCodeFormatting(memberModal.querySelector('#general_detail_cod_org'));
    }
    if(fixedReqTable){
        fixedReqTable.querySelectorAll('.fixed_req_data_row').forEach(row => attachFixedReqActions(row));
    }
    if(addFixedReqButton){
        addFixedReqButton.addEventListener('click', () => {
            if(fixedReqTable.querySelector('.fixed_req_row.creando')){return;}
            const row = createFixedReqConfigRow('', '', '', true);
            const addRow = fixedReqTable.querySelector('.fixed_req_add_row');
            fixedReqTable.insertBefore(row, addRow);
            setFixedReqEditMode(row,true);
        });
    }
    applyStoredIndexPanel();

    function openPanel(saveState = false){
        panel.classList.add('mostrar');
        panel.classList.remove('ocultar');
        if(nominaPanel){nominaPanel.classList.add('ocultar');}
        if(saveState){localStorage.setItem(activeIndexPanelKey,'ajustes_generales');}
    }

    function closePanel(saveState = false){
        panel.classList.remove('mostrar');
        panel.classList.add('ocultar');
        if(nominaPanel){nominaPanel.classList.remove('ocultar');}
        if(saveState){localStorage.setItem(activeIndexPanelKey,'nominas');}
    }

    function applyStoredIndexPanel(){
        const storedPanel = localStorage.getItem(activeIndexPanelKey) || 'nominas';
        if(storedPanel === 'ajustes_generales'){
            openPanel(false);
        }else{
            closePanel(false);
        }
    }

    function filterGlobalMembers(value){
        const term = quitarAcentos(String(value || '').toLowerCase());
        const rows = table.querySelectorAll('.row_miembro:not(.header_miembro)');
        let visibleRows = 0;

        rows.forEach(row => {
            if(row.classList.contains('emptyMessage')){return;}
            const text = quitarAcentos(row.textContent.toLowerCase());
            const visible = text.indexOf(term) !== -1;
            row.classList.toggle('oculta', !visible);
            if(visible){visibleRows += 1;}
        });

        const empty = table.querySelector('.emptyMessage');
        if(empty){
            empty.style.display = visibleRows === 0 ? 'block' : 'none';
        }
    }

    function openMemberModal(){
        memberModal.classList.add('mostrar');
        memberModal.classList.remove('ocultar');
        if(layout){layout.classList.add('mostrar');}
    }

    function closeMemberModal(){
        memberModal.classList.remove('mostrar');
        memberModal.classList.add('ocultar');
        memberModal.querySelector('.detail_delete_confirm').classList.remove('mostrar');
        if(selectedRow){selectedRow.classList.remove('selected');}
        selectedRow = null;
        initialState = null;
        clearGeneralMemberModal();
        if(layout){
            layout.classList.remove('mostrar');
        }
    }

    function openMemberModalForCreate(){
        selectedRow = null;
        clearGeneralMemberModal();
        memberModal.querySelector('.btn_submit.eliminar').style.display = 'none';
        memberModal.querySelector('.campo.observacion_importada').style.display = 'none';
        renderGlobalFixedRequirements(getFixedRequirementConfigFromTable(), true);
        initialState = null;
        openMemberModal();
    }

    async function openMemberModalForEdit(row){
        if(selectedRow){selectedRow.classList.remove('selected');}
        selectedRow = row;
        row.classList.add('selected');
        memberModal.querySelector('.btn_submit.eliminar').style.display = 'flex';
        memberModal.querySelector('.campo.observacion_importada').style.display = '';
        openMemberModal();
        setGlobalFixedRequirementsLoading();
        fillGlobalMemberFieldsFromRow(row);

        try {
            const response = await fetch('/api/getGlobalMemberDetail.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({'Doc':row.dataset.doc})
            });
            const data = await response.json();
            if(data['response'] == 200){
                fillGlobalMemberFields(data['data']['Member']);
                renderGlobalFixedRequirements(data['data']['RequisitosFijos'], false);
                initialState = getGlobalMemberState(false);
            }else{
                showAlert('error',data['error'] || 'No se pudo cargar el miembro');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','No se pudo cargar el miembro');
        }
    }

    function clearGeneralMemberModal(){
        memberModal.querySelector('#general_detail_internal_id').value = '';
        memberModal.querySelector('#general_detail_doc').value = '';
        memberModal.querySelector('#general_detail_doc').readOnly = false;
        memberModal.querySelector('#general_detail_nombre').value = '';
        memberModal.querySelector('#general_detail_cod_org').value = '';
        memberModal.querySelector('#general_detail_org').value = '';
        memberModal.querySelector('#general_detail_rama').value = 0;
        memberModal.querySelector('#general_detail_observacion_importada').value = '';
        memberModal.querySelector('#general_detail_observacion_manual').value = '';
        memberModal.querySelector('.req_body.fijos').innerHTML = '';
    }

    function fillGlobalMemberFieldsFromRow(row){
        memberModal.querySelector('#general_detail_internal_id').value = row.dataset.internal || '';
        memberModal.querySelector('#general_detail_doc').value = row.dataset.doc || '';
        memberModal.querySelector('#general_detail_doc').readOnly = true;
        memberModal.querySelector('#general_detail_nombre').value = row.dataset.nombre || '';
        memberModal.querySelector('#general_detail_cod_org').value = row.dataset.codOrg || '';
        memberModal.querySelector('#general_detail_org').value = row.dataset.organismo || '';
        memberModal.querySelector('#general_detail_rama').value = row.dataset.rama || 0;
        memberModal.querySelector('#general_detail_observacion_importada').value = '';
        memberModal.querySelector('#general_detail_observacion_manual').value = '';
    }

    function fillGlobalMemberFields(member){
        memberModal.querySelector('#general_detail_internal_id').value = member.InternalId;
        memberModal.querySelector('#general_detail_doc').value = member.Doc;
        memberModal.querySelector('#general_detail_doc').readOnly = true;
        memberModal.querySelector('#general_detail_nombre').value = member.Nombre;
        memberModal.querySelector('#general_detail_cod_org').value = normalizeOrgCode(member.CodOrganismo);
        memberModal.querySelector('#general_detail_org').value = member.NombreOrganismo;
        memberModal.querySelector('#general_detail_rama').value = member.CodRama;
        memberModal.querySelector('#general_detail_observacion_importada').value = member.ObservacionImportada || '';
        memberModal.querySelector('#general_detail_observacion_manual').value = member.ObservacionManual || '';
    }

    function setGlobalFixedRequirementsLoading(){
        memberModal.querySelector('.req_body.fijos').innerHTML = '<div class="req_empty"><p>Cargando requisitos...</p></div>';
    }

    function renderGlobalFixedRequirements(requirements, isCreate){
        const body = memberModal.querySelector('.req_body.fijos');
        body.innerHTML = '';

        if(!requirements || requirements.length === 0){
            body.innerHTML = '<div class="req_empty"><p>No hay requisitos fijos configurados</p></div>';
            return;
        }

        requirements.forEach(req => {
            const row = document.createElement('div');
            row.classList.add('req_row','fixed');
            row.dataset.id = req.IdRequisito || req.internalId;
            row.dataset.defaultValidity = req.DefaultValidity || '';
            row.innerHTML = `
                <p class="req_name"></p>
                <div class="req_link_field">
                    <input type="url" value="" placeholder="URL">
                    <a href="#" target="_blank" rel="noopener" title="Abrir adjunto">
                        <i class="fa-solid fa-link"></i>
                    </a>
                </div>
                <input class="req_validity" type="date" value="">
                <label class="switch req_check">
                    <input type="checkbox">
                    <span class="checkmark"></span>
                </label>
            `;
            row.querySelector('.req_name').textContent = req.Nombre;
            const validity = req.ValidoHasta || req.DefaultValidity || '';
            row.querySelector('.req_validity').value = validity;
            row.querySelector('.req_check input').checked = !isCreate && Number(req.Marcado || 0) === 1;
            const urlInput = row.querySelector('.req_link_field input');
            const urlLink = row.querySelector('.req_link_field a');
            urlInput.value = req.Adjunto || '';
            updateGlobalRequirementLink(urlLink,urlInput.value);
            urlInput.addEventListener('input', () => updateGlobalRequirementLink(urlLink,urlInput.value));
            row.querySelector('.req_check input').addEventListener('change', event => {
                const validityInput = row.querySelector('.req_validity');
                if(event.target.checked && !validityInput.value && row.dataset.defaultValidity){
                    validityInput.value = row.dataset.defaultValidity;
                }
                updateFixedRequirementExpiredState(row);
            });
            row.querySelector('.req_validity').addEventListener('change', () => updateFixedRequirementExpiredState(row));
            updateFixedRequirementExpiredState(row);
            body.appendChild(row);
        });
    }

    function updateGlobalRequirementLink(link,url){
        if(url){
            link.href = url;
            link.classList.remove('disabled');
        }else{
            link.href = '#';
            link.classList.add('disabled');
        }
    }

    function getGlobalMemberState(validate = true){
        const doc = memberModal.querySelector('#general_detail_doc').value.replace(/\D/g, '');
        const nombre = memberModal.querySelector('#general_detail_nombre').value.trim();
        const codOrg = normalizeOrgCode(memberModal.querySelector('#general_detail_cod_org').value);
        const organismo = memberModal.querySelector('#general_detail_org').value.trim();
        const rama = memberModal.querySelector('#general_detail_rama').value;
        const ramaSelect = memberModal.querySelector('#general_detail_rama');
        const nombreRama = ramaSelect.options[ramaSelect.selectedIndex] ? ramaSelect.options[ramaSelect.selectedIndex].text : '';

        if(validate){
            let errorMsg = 'Faltó completar ';
            let error = false;
            if(!doc){errorMsg += 'DNI. '; error = true;}
            if(!nombre){errorMsg += 'Nombre. '; error = true;}
            if(!codOrg){errorMsg += 'Nro. Organismo. '; error = true;}
            if(!organismo){errorMsg += 'Organismo. '; error = true;}
            if(!rama || rama == 0){errorMsg += 'Rama. '; error = true;}
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
        }

        return {
            'InternalId':memberModal.querySelector('#general_detail_internal_id').value,
            'Doc':doc,
            'Nombre':nombre,
            'Rama':rama,
            'NombreRama':nombreRama,
            'CodOrg':codOrg,
            'Organismo':organismo,
            'ObservacionImportada':memberModal.querySelector('#general_detail_observacion_importada').value,
            'ObservacionManual':memberModal.querySelector('#general_detail_observacion_manual').value.trim(),
            'Active':true,
            'RequisitosFijos':getGlobalFixedRequirementsPayload()
        };
    }

    function getGlobalFixedRequirementsPayload(){
        return Array.from(memberModal.querySelectorAll('.req_body.fijos .req_row:not(.example)')).map(row => {
            return {
                'IdRequisito':row.dataset.id,
                'Adjunto':row.querySelector('.req_link_field input').value,
                'ValidoHasta':row.querySelector('.req_validity').value,
                'Marcado':row.querySelector('input[type="checkbox"]').checked
            };
        });
    }

    function normalizeGlobalMemberState(state){
        if(!state){return null;}
        return {
            'InternalId':String(state.InternalId || ''),
            'Doc':String(state.Doc || ''),
            'Nombre':String(state.Nombre || '').trim(),
            'Rama':String(state.Rama || ''),
            'CodOrg':normalizeOrgCode(state.CodOrg),
            'Organismo':String(state.Organismo || '').trim(),
            'ObservacionImportada':String(state.ObservacionImportada || ''),
            'ObservacionManual':String(state.ObservacionManual || '').trim(),
            'RequisitosFijos':[...state.RequisitosFijos].map(req => {
                return {
                    'IdRequisito':String(req.IdRequisito || ''),
                    'Adjunto':String(req.Adjunto || '').trim(),
                    'ValidoHasta':String(req.ValidoHasta || ''),
                    'Marcado':Boolean(req.Marcado)
                };
            }).sort((a,b) => a.IdRequisito.localeCompare(b.IdRequisito))
        };
    }

    async function saveGlobalMember(){
        const state = getGlobalMemberState();
        if(!state){return;}

        if(initialState && JSON.stringify(normalizeGlobalMemberState(state)) === JSON.stringify(normalizeGlobalMemberState(initialState))){
            showAlert('error','No hay cambios en los datos');
            return;
        }

        if(loader){loader.classList.add('loading');}
        try {
            const response = await fetch('/api/saveGlobalMember.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(state)
            });
            const data = await response.json();
            if(data['response'] == 200){
                state.InternalId = data['internalId'];
                upsertGlobalMemberRow(state);
                showAlert('success','Miembro guardado correctamente');
                closeMemberModal();
            }else{
                showAlert('error',data['error'] || 'Error al guardar miembro');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al guardar miembro');
        }
        if(loader){loader.classList.remove('loading');}
    }

    async function deleteGlobalMember(){
        if(!selectedRow){return;}
        if(loader){loader.classList.add('loading');}

        try {
            const response = await fetch('/api/deleteGlobalMember.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({'Doc':selectedRow.dataset.doc})
            });
            const data = await response.json();
            if(data['response'] == 200){
                selectedRow.remove();
                showAlert('success','Miembro eliminado correctamente');
                closeMemberModal();
                updateGlobalMembersEmptyMessage();
            }else{
                showAlert('error',data['error'] || 'Error al eliminar miembro');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al eliminar miembro');
        }

        if(loader){loader.classList.remove('loading');}
    }

    function upsertGlobalMemberRow(member){
        let row = table.querySelector(`.row_miembro:not(.header_miembro)[data-doc="${member.Doc}"]`);
        const isNew = !row;
        if(!row){
            row = document.createElement('div');
            row.classList.add('row_miembro','activo');
        }

        row.dataset.doc = member.Doc;
        row.dataset.internal = member.InternalId;
        row.dataset.nombre = member.Nombre;
        row.dataset.codOrg = member.CodOrg;
        row.dataset.organismo = member.Organismo;
        row.dataset.rama = member.Rama;
        row.dataset.activo = '1';
        row.innerHTML = `
            <div class="campo campo_internal" style="display: none;"><p>${member.InternalId}</p></div>
            <div class="campo campo_nombre"><p></p></div>
            <div class="campo campo_doc"><p>${member.Doc}</p></div>
            <div class="campo campo_org"><p></p></div>
            <div class="campo campo_rama" title=""></div>
            <div class="campo campo_codrama" style="display: none;"><p>${member.Rama}</p></div>
            <div class="campo campo_req_fijos" title="Requisitos fijos"><div class="circulo_requisito incompleto"></div></div>
        `;
        row.querySelector('.campo_nombre p').textContent = member.Nombre;
        row.querySelector('.campo_org p').textContent = `${member.CodOrg}-${member.Organismo}`;
        const ramaCell = row.querySelector('.campo_rama');
        ramaCell.className = 'campo campo_rama ' + member.Rama.replace(/\d/g, '').toLowerCase();
        ramaCell.title = member.NombreRama;
        ramaCell.innerHTML = '<p></p>';
        ramaCell.querySelector('p').textContent = member.NombreRama;
        setRequirementSummaryCircle(row,'.campo_req_fijos',areFixedRequirementsComplete(member.RequisitosFijos));

        if(isNew){
            const empty = table.querySelector('.emptyMessage');
            table.insertBefore(row, empty || null);
        }
        applyCurrentMemberTableSort(table);
        updateGlobalMembersEmptyMessage();
    }

    function updateGlobalMembersEmptyMessage(){
        const empty = table.querySelector('.emptyMessage');
        if(!empty){return;}
        const rows = table.querySelectorAll('.row_miembro:not(.header_miembro):not(.emptyMessage)');
        empty.style.display = rows.length === 0 ? 'block' : 'none';
    }

    function getFixedRequirementConfigFromTable(){
        return Array.from(fixedReqTable.querySelectorAll('.fixed_req_data_row')).map(row => {
            return {
                'internalId':row.dataset.id,
                'Nombre':getFixedReqName(row),
                'DefaultValidity':getFixedReqValidity(row)
            };
        });
    }

    function createFixedReqConfigRow(id,name,validity,isNew = false){
        const row = document.createElement('div');
        row.classList.add('fixed_req_row','fixed_req_data_row');
        if(isNew){row.classList.add('creando');}
        if(id){row.dataset.id = id;}
        row.innerHTML = `
            <div class="fixed_req_name"><p></p></div>
            <div class="fixed_req_validity"><p></p></div>
            <div class="fixed_req_actions">
                <div class="campo edit_fixed_req" title="Editar requisito"><i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i></div>
                <div class="campo delete_fixed_req" title="Eliminar requisito"><i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i></div>
            </div>
        `;
        row.querySelector('.fixed_req_name p').textContent = name;
        row.querySelector('.fixed_req_validity p').textContent = validity;
        attachFixedReqActions(row);
        return row;
    }

    function attachFixedReqActions(row){
        const edit = row.querySelector('.edit_fixed_req');
        const remove = row.querySelector('.delete_fixed_req');
        if(edit){edit.addEventListener('click', () => setFixedReqEditMode(row,false));}
        if(remove){remove.addEventListener('click', () => setFixedReqDeleteMode(row));}
    }

    function setFixedReqEditMode(row,isNew){
        const currentName = getFixedReqName(row);
        const currentValidity = getFixedReqValidity(row);
        row.querySelector('.fixed_req_name').innerHTML = '<input type="text" value="">';
        row.querySelector('.fixed_req_validity').innerHTML = '<input type="date" value="">';
        row.querySelector('.fixed_req_name input').value = currentName;
        row.querySelector('.fixed_req_validity input').value = currentValidity;
        setFixedReqConfirmActions(row, async () => {
            const name = row.querySelector('.fixed_req_name input').value.trim();
            const validity = row.querySelector('.fixed_req_validity input').value;
            if(!name || !validity){
                showAlert('error','Debes completar nombre y validez por defecto');
                return;
            }
            const success = isNew ? await createFixedRequirement(name,validity,row) : await updateFixedRequirement(name,validity,row);
            if(success){
                row.classList.remove('creando');
                renderFixedReqReadMode(row,name,validity);
                showAlert('success',isNew ? 'Requisito fijo creado correctamente' : 'Requisito fijo actualizado correctamente');
            }
        }, () => {
            if(isNew){
                row.remove();
            }else{
                renderFixedReqReadMode(row,currentName,currentValidity);
            }
        });
    }

    function setFixedReqDeleteMode(row){
        setFixedReqConfirmActions(row, async () => {
            const success = await deleteFixedRequirement(row);
            if(success){
                row.remove();
                showAlert('success','Requisito fijo eliminado correctamente');
            }
        }, () => renderFixedReqReadMode(row,getFixedReqName(row),getFixedReqValidity(row)));
    }

    function setFixedReqConfirmActions(row,onConfirm,onCancel){
        const actions = row.querySelector('.fixed_req_actions');
        actions.innerHTML = `
            <div class="campo confirm_fixed_req" title="Confirmar"><i class="fa-solid fa-check fa-xl" style="color: #287a35;"></i></div>
            <div class="campo cancel_fixed_req" title="Cancelar"><i class="fa-solid fa-xmark fa-xl" style="color: #ad272d;"></i></div>
        `;
        actions.querySelector('.confirm_fixed_req').addEventListener('click', onConfirm);
        actions.querySelector('.cancel_fixed_req').addEventListener('click', onCancel);
    }

    function renderFixedReqReadMode(row,name,validity){
        row.querySelector('.fixed_req_name').innerHTML = '<p></p>';
        row.querySelector('.fixed_req_validity').innerHTML = '<p></p>';
        row.querySelector('.fixed_req_name p').textContent = name;
        row.querySelector('.fixed_req_validity p').textContent = validity;
        row.querySelector('.fixed_req_actions').innerHTML = `
            <div class="campo edit_fixed_req" title="Editar requisito"><i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i></div>
            <div class="campo delete_fixed_req" title="Eliminar requisito"><i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i></div>
        `;
        attachFixedReqActions(row);
    }

    function getFixedReqName(row){
        const input = row.querySelector('.fixed_req_name input');
        const text = row.querySelector('.fixed_req_name p');
        return input ? input.value : (text ? text.textContent : '');
    }

    function getFixedReqValidity(row){
        const input = row.querySelector('.fixed_req_validity input');
        const text = row.querySelector('.fixed_req_validity p');
        return input ? input.value : (text ? text.textContent : '');
    }

    async function createFixedRequirement(name,validity,row){
        const data = await saveFixedRequirement('/api/createFixedRequirement.php', {'Nombre':name,'DefaultValidity':validity});
        if(data && data['response'] == 200){
            row.dataset.id = data['internalId'];
            return true;
        }
        return false;
    }

    async function updateFixedRequirement(name,validity,row){
        const data = await saveFixedRequirement('/api/editFixedRequirement.php', {'Nombre':name,'DefaultValidity':validity,'InternalId':row.dataset.id});
        return data && data['response'] == 200;
    }

    async function deleteFixedRequirement(row){
        const data = await saveFixedRequirement('/api/deleteFixedRequirement.php', {'InternalId':row.dataset.id});
        return data && data['response'] == 200;
    }

    async function saveFixedRequirement(url,payload){
        if(panel.dataset.savingFixedReq === '1'){
            return false;
        }

        panel.dataset.savingFixedReq = '1';
        if(loader){loader.classList.add('loading');}
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if(data['response'] != 200){
                showAlert('error',data['error'] || 'Error al guardar requisito fijo');
            }
            return data;
        } catch (error) {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al guardar requisito fijo');
            return false;
        } finally {
            delete panel.dataset.savingFixedReq;
            if(loader){loader.classList.remove('loading');}
        }
    }
}

function listenExcelImportMapper(){
    const modal = document.querySelector('.excel_mapper_modal');
    if(!modal){return;}

    const forms = [
        {element: document.querySelector('.general_import_members'), type: 'global'},
        {element: document.querySelector('.form_miembros form'), type: 'nomina'}
    ].filter(item => item.element);
    const fieldsContainer = modal.querySelector('.excel_mapper_fields');
    const requirementsSection = modal.querySelector('.excel_mapper_requirements_section');
    const requirementsContainer = modal.querySelector('.excel_mapper_requirements');
    const previewTable = modal.querySelector('.excel_mapper_preview table');
    const status = modal.querySelector('.excel_mapper_status');
    const loader = modal.querySelector('.excel_mapper_loader');
    const saveInput = modal.querySelector('.excel_mapper_save input');
    let importToken = '';
    let analysis = null;
    let fieldLabels = {};
    let requirementFields = [];

    forms.forEach(item => {
        item.element.addEventListener('submit', async event => {
            event.preventDefault();
            const input = item.element.querySelector('input[type="file"]');
            if(!input || !input.files.length){
                showAlert('error','Debes seleccionar un archivo');
                return;
            }
            await analyzeFile(input.files[0], item.type);
        });
    });

    modal.querySelector('.excel_mapper_close').addEventListener('click', closeModal);
    modal.querySelector('.excel_mapper_cancel').addEventListener('click', closeModal);
    modal.querySelector('.excel_mapper_confirm').addEventListener('click', confirmImport);
    modal.addEventListener('click', event => {
        if(event.target === modal){closeModal();}
    });
    document.addEventListener('keydown', event => {
        if(event.key === 'Escape' && modal.classList.contains('mostrar')){closeModal();}
    });

    async function analyzeFile(file, type){
        setLoading(true);
        const payload = new FormData();
        payload.append('excel', file);
        payload.append('type', type);
        if(type === 'nomina'){
            payload.append('nomina', typeof nominaNr !== 'undefined' ? nominaNr : '');
        }

        try {
            const response = await fetch('/api/analyzeExcelImport.php', {
                method: 'POST',
                body: payload
            });
            const data = await response.json();
            if(data.response !== 200){
                showAlert('error', data.error || 'No se pudo analizar el archivo');
                return;
            }
            importToken = data.token;
            analysis = data.analysis;
            fieldLabels = data.fields;
            requirementFields = data.requirementFields || [];
            renderMapper();
            openModal();
        } catch(error) {
            console.error('Error al analizar Excel:', error);
            showAlert('error','No se pudo analizar el archivo');
        } finally {
            setLoading(false);
            document.querySelectorAll('.cont_loader_miembro, .general_settings_loader')
                .forEach(item => item.classList.remove('loading'));
        }
    }

    function renderMapper(){
        fieldsContainer.innerHTML = '';
        status.className = 'excel_mapper_status';
        status.textContent = analysis.ScoutFormat
            ? 'Formato CDS reconocido. Revisá las columnas antes de importar.'
            : 'Formato personalizado. Completá la relación de columnas.';
        status.classList.add(analysis.ScoutFormat ? 'detected' : 'custom');

        Object.keys(fieldLabels).forEach(field => {
            const row = document.createElement('label');
            row.className = 'excel_mapper_field';
            const fieldName = document.createElement('span');
            fieldName.textContent = fieldLabels[field];
            const select = document.createElement('select');
            select.dataset.field = field;
            select.innerHTML = '<option value="">-- Seleccionar columna --</option>';

            analysis.Columns.forEach(column => {
                const option = document.createElement('option');
                option.value = column.letter;
                option.textContent = column.letter + ' — ' + column.header;
                option.selected = analysis.Mapping[field] === column.letter;
                select.appendChild(option);
            });
            select.addEventListener('change', () => {
                if(select.value){row.classList.remove('error');}
                renderPreview();
            });
            row.append(fieldName, select);
            fieldsContainer.appendChild(row);
        });
        renderRequirementFields();
        renderPreview();
    }

    function renderRequirementFields(){
        requirementsContainer.innerHTML = '';

        if(!requirementFields.length){
            requirementsSection.style.display = 'none';
            return;
        }
        requirementsSection.style.display = '';

        requirementFields.forEach(req => {
            const row = document.createElement('label');
            row.className = 'excel_mapper_field';
            const fieldName = document.createElement('span');
            fieldName.textContent = req.Nombre + (req.Type === 'eventual' ? ' (eventual)' : ' (fijo)');
            const select = document.createElement('select');
            select.dataset.reqKey = req.Key;
            select.dataset.reqType = req.Type;
            select.dataset.reqId = req.IdRequisito;
            select.innerHTML = '<option value="">-- Sin asignar --</option>';

            analysis.Columns.forEach(column => {
                const option = document.createElement('option');
                option.value = column.letter;
                option.textContent = column.letter + ' — ' + column.header;
                select.appendChild(option);
            });
            select.addEventListener('change', renderPreview);
            row.append(fieldName, select);
            requirementsContainer.appendChild(row);
        });
    }

    function getMapping(){
        const mapping = {};
        fieldsContainer.querySelectorAll('select').forEach(select => {
            mapping[select.dataset.field] = select.value;
        });
        return mapping;
    }

    function getRequirementMapping(){
        const mapping = [];
        requirementsContainer.querySelectorAll('select').forEach(select => {
            if(!select.value){return;}
            mapping.push({
                Type: select.dataset.reqType,
                IdRequisito: select.dataset.reqId,
                Column: select.value
            });
        });
        return mapping;
    }

    function renderPreview(){
        const mapping = getMapping();
        const requirementMapping = getRequirementMapping();
        const fields = Object.keys(fieldLabels);
        previewTable.innerHTML = '';
        const head = document.createElement('thead');
        const headRow = document.createElement('tr');
        fields.forEach(field => {
            const cell = document.createElement('th');
            cell.textContent = fieldLabels[field];
            headRow.appendChild(cell);
        });
        requirementFields.forEach(req => {
            const cell = document.createElement('th');
            cell.textContent = req.Nombre;
            headRow.appendChild(cell);
        });
        head.appendChild(headRow);
        previewTable.appendChild(head);

        const body = document.createElement('tbody');
        analysis.Preview.forEach(sourceRow => {
            const row = document.createElement('tr');
            fields.forEach(field => {
                const cell = document.createElement('td');
                cell.textContent = mapping[field] ? (sourceRow[mapping[field]] || '') : '—';
                row.appendChild(cell);
            });
            requirementFields.forEach(req => {
                const cell = document.createElement('td');
                const match = requirementMapping.find(item => item.Type === req.Type && String(item.IdRequisito) === String(req.IdRequisito));
                cell.textContent = match ? (sourceRow[match.Column] || '') : '—';
                row.appendChild(cell);
            });
            body.appendChild(row);
        });
        previewTable.appendChild(body);
    }

    function showMapperError(message){
        status.className = 'excel_mapper_status error';
        status.textContent = message;
        status.scrollIntoView({behavior:'smooth', block:'nearest'});
        showAlert('error',message);
    }

    function clearFieldErrors(){
        fieldsContainer.querySelectorAll('.excel_mapper_field.error').forEach(row => row.classList.remove('error'));
    }

    function markEmptyRequiredFields(mapping,requiredFields){
        clearFieldErrors();
        let firstEmpty = null;

        fieldsContainer.querySelectorAll('select').forEach(select => {
            if(!requiredFields.includes(select.dataset.field) || select.value){return;}

            const row = select.closest('.excel_mapper_field');
            row.classList.add('error');
            firstEmpty = firstEmpty || select;
        });

        if(firstEmpty){firstEmpty.scrollIntoView({behavior:'smooth', block:'center'});}
    }

    async function confirmImport(){
        const mapping = getMapping();
        const requirementMapping = getRequirementMapping();
        const requiredFields = Object.keys(mapping).filter(field => field !== 'ObservacionImportada');
        const selected = Object.values(mapping).filter(value => value);
        const selectedRequirementColumns = requirementMapping.map(item => item.Column);

        if(requiredFields.some(field => !mapping[field])){
            markEmptyRequiredFields(mapping,requiredFields);
            showMapperError('Faltan columnas por asignar: marcamos en rojo los campos que te faltan completar.');
            return;
        }
        clearFieldErrors();

        const allSelected = [...selected, ...selectedRequirementColumns];
        if(new Set(allSelected).size !== allSelected.length){
            showMapperError('Una misma columna no puede usarse para más de un campo.');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('/api/confirmExcelImport.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    token: importToken,
                    mapping,
                    requirementMapping,
                    saveMapping: saveInput.checked
                })
            });
            const data = await response.json();
            if(data.response !== 200){
                setLoading(false);
                showMapperError(data.error || 'No se pudieron importar los miembros');
                return;
            }

            // No se apaga el loader ni se cierra el modal: la página se recarga sola
            // y hasta que eso pase tiene que sentirse que sigue importando.
            window.location.href = data.redirect || (typeof nominaNr !== 'undefined' && nominaNr ? ('/nomina.php?id='+nominaNr) : '/');
        } catch(error) {
            console.error('Error al importar Excel:', error);
            setLoading(false);
            showMapperError('No se pudieron importar los miembros. Volvé a intentarlo.');
        }
    }

    function openModal(){
        modal.classList.add('mostrar');
        modal.classList.remove('ocultar');
        document.body.classList.add('excel_mapper_open');
    }

    function closeModal(){
        modal.classList.remove('mostrar');
        modal.classList.add('ocultar');
        document.body.classList.remove('excel_mapper_open');
    }

    function setLoading(active){
        loader.classList.toggle('loading', active);
    }
}

// INICIO REFRESHS

// CATEGORIA PAGOS
function refreshCatPagosInPanel(categ,intId,action='create'){
    const panel_pagos = document.querySelector('.panel_pagos');
    if(panel_pagos){
        const cont_categorias = panel_pagos.querySelector('.cont_categorias');
        const agregar_categ = panel_pagos.querySelector('.categorias.agregar');

        if(action == 'create'){
            const category = document.createElement('DIV');
            const nombre = document.createElement('P');
            const valor = document.createElement('P');
    
            category.classList.add('categorias');
            category.title = categ;
            category.setAttribute('data-id',intId);
    
            nombre.classList.add('nombre');
            valor.classList.add('valor');
            nombre.textContent = categ;
            valor.textContent = '$ 0'
    
            category.appendChild(nombre);
            category.appendChild(valor);
    
            cont_categorias.insertBefore(category, agregar_categ);
    
    
            const newPanelPagos = panel_pagos.cloneNode(true); // true = clona hijos también
            panel_pagos.parentNode.replaceChild(newPanelPagos, panel_pagos);

            completePagosDetail(false,true);
        }else if(action == 'delete'){
            const category = cont_categorias.querySelector(`.categorias[data-id="${intId}"]`);
            if(category){
                category.remove();
            }
        }else if(action == 'update'){
            const category = cont_categorias.querySelector(`.categorias[data-id="${intId}"]`);
            if (category){
                const nombre = category.querySelector(`.nombre`);
                nombre.textContent = categ;
            }
        }
    }
}

function refreshCatPagosInConfig(categ,intId){
    const cont_categ = document.querySelector(".contenido_categorias");
    if(cont_categ){
        const agregar_categ = cont_categ.querySelector(".agregar_categ");

        newCateg = createNewCategory();
        completeCategory(newCateg,categ,intId)
        cont_categ.insertBefore(newCateg, agregar_categ);


        function completeCategory(categ,nombre,intId){
            const nombreInput = categ.querySelector(".nombre_categ input");
            const accionesCateg = categ.querySelector(".acciones_categ");
            const confirmCateg = categ.querySelector(".confirmar_categ");
            const anularCreacion = categ.querySelector(".anular_creacion");

            creation = false;
            categ.setAttribute('data-id', intId);
            
            nombreInput.value = nombre;
            nombreInput.readOnly = true;
            nombreInput.name = `nombre_${intId}`;
            nombreInput.id = `nombre_${intId}`;

            confirmCateg.remove();
            anularCreacion.remove();

            const editar = document.createElement('div');
            editar.className = 'campo editar_categ';
            editar.title = 'Editar Categoria';
            editar.innerHTML = `<i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>`;

            const eliminar = document.createElement('div');
            eliminar.className = 'campo eliminar_categ';
            eliminar.title = 'Eliminar Categoria';
            eliminar.innerHTML = `<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>`;

            accionesCateg.appendChild(editar);
            accionesCateg.appendChild(eliminar);

            activeCategoryAction(categ);
        }
    }
}

function refreshCatPagosListCaja(categ,intId,action='create'){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const filtro_general = panel_caja.querySelector('.contenido_filtros .filtro_categoria');
        const select_filtro = filtro_general.querySelector('.select_filtro');

        if(action == 'create'){            
            const option = document.createElement('div');
            option.id = 'category_' + intId;
            option.classList.add('opciones_categoria');
            option.textContent = categ;
            select_filtro.appendChild(option);
    
    
            const newSelect = select_filtro.cloneNode(true); // true = clona hijos también
            select_filtro.parentNode.replaceChild(newSelect, select_filtro);
    
            activeCajaCategOptions();
            const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
            filtro_caja_diaria.dispatchEvent(new Event('change'));

        }else if(action == 'delete'){
            const category = select_filtro.querySelector(`#category_${intId}`);
            if(category){
                category.remove();
            }

        }else if(action == 'update'){
            const category = select_filtro.querySelector(`#category_${intId}`);
            if (category){
                category.textContent = categ;
            }
        }
    }
}

// UNIDADES 
async function refreshRamas(){

    const ramas = await getRamasDicFromAPI();
    refreshRamasInListCaja(ramas);
    refreshRamasInMembersPanel(ramas);
    refreshRamasInMembersForm(ramas);
    refreshRamasInCampasPanel(ramas);
    refreshRamasInCampasForm(ramas);
    refreshRamasInEventosPanel(ramas);
    refreshRamasInEventosForm(ramas);
}

async function getRamasDicFromAPI(){
    try {
        const response = await fetch('/api/getRamasDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Unidades');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshRamasInMembersPanel(ramas){
    const configMembers = document.querySelector('.panel_config.config_miembros')

    if(configMembers){
        const selectRama = configMembers.querySelectorAll('.campo.campo_rama select');

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        selectRama.forEach(select => {
            const valorSeleccionado = select.value;
    
            select.innerHTML = '';
            ramasOrdenadas.forEach(rama => {
                const optRama = document.createElement('OPTION');
                const codRama = rama.CodRama.split('-')[1]; 
                optRama.value = codRama;
                optRama.textContent = rama.Nombre;

                if (codRama == valorSeleccionado) {
                    optRama.selected = true;
                }
    
                select.appendChild(optRama);
            });

        })

    }
}

function refreshRamasInMembersForm(ramas){
    const formMiembros = document.querySelectorAll('.form_miembro_indv:not(.delete)')

    if(formMiembros.length > 0){

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        formMiembros.forEach(form => {
            const selectRama = form.querySelector('.campo.rama select')
            selectRama.innerHTML = '';

            const defRama = document.createElement('OPTION');
            defRama.value = 0;
            defRama.textContent = '--Seleccione--';
            defRama.disabled = true;
            defRama.selected = true;
            selectRama.appendChild(defRama);

            ramasOrdenadas.forEach(rama => {
                const optRama = document.createElement('OPTION');
                const codRama = rama.CodRama.split('-')[1]; 
                optRama.value = codRama;
                optRama.textContent = rama.Nombre;
    
                selectRama.appendChild(optRama);
            });
        })

    }
}

// FIN REFRESHS  

const ALERT_TYPES = {
    error: 'error',
    success: 'success',
    warning: 'warning',
    info: 'info'
};

const ALERT_DEFAULT_TYPE = ALERT_TYPES.error;
const ALERT_DEFAULT_MESSAGE = 'Algo Salio Mal';
const ALERT_DURATION = 3000;
const ALERT_EXIT_DURATION = 450;

function normalizeAlertType(type) {
    return Object.prototype.hasOwnProperty.call(ALERT_TYPES, type) ? ALERT_TYPES[type] : ALERT_DEFAULT_TYPE;
}

function getAlertIcon() {
    return `
        <svg
            class="alertMsg__icon"
            stroke="currentColor"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke-width="2"
                stroke-linejoin="round"
                stroke-linecap="round"
            ></path>
        </svg>
    `;
}

function setAlertContent(alerta,msg) {
    alerta.setAttribute('role', 'alert');
    alerta.innerHTML = getAlertIcon();

    const text = document.createElement('p');
    text.classList.add('alertMsg__text');
    text.textContent = msg;
    alerta.appendChild(text);
}

function showAlert(type = ALERT_DEFAULT_TYPE,msg=ALERT_DEFAULT_MESSAGE) {
    let alerta = document.querySelector(".alertMsg.default");
    if(!alerta){
        return;
    }

    const alertType = normalizeAlertType(type);
    alerta.className = ''; // Se le elimina por si ya tuvo otro estilo
    alerta.classList.add('alertMsg','default'); // Se le vuelven a agregar los basicos

    alerta.style.display = "flex";
    alerta.style.opacity = "1";
    alerta.classList.add(alertType, 'alertMsg--show');
    setAlertContent(alerta,msg);

    setTimeout(() => {
        alerta.classList.remove('alertMsg--show');
        alerta.classList.add('alertMsg--hide');
        setTimeout(() => {
            alerta.style.display = "none";
            alerta.classList.remove('alertMsg--hide');
        }, ALERT_EXIT_DURATION);
    }, ALERT_DURATION); // El mensaje dura 3 segundos antes de desaparecer

}

function showFormAlert(type = ALERT_DEFAULT_TYPE) {
    let alertas = document.querySelectorAll(".alertMsg.form");
    const alertType = normalizeAlertType(type);
    let top = 0;

    alertas.forEach((alerta)=>{
        const msg = alerta.textContent;

        alerta.className = ''; // Se le elimina por si ya tuvo otro estilo
        alerta.classList.add('alertMsg','default'); // Se le vuelven a agregar los basicos

        alerta.style.display = "flex";
        alerta.style.opacity = "1";
        if(top > 0){
            alerta.style.top = top + 'rem';
        }
        top += 6
        alerta.classList.add(alertType, 'alertMsg--show');
        setAlertContent(alerta,msg);

        setTimeout(() => {
            alerta.classList.remove('alertMsg--show');
            alerta.classList.add('alertMsg--hide');
            setTimeout(() => {
                alerta.style.display = "none";
                alerta.classList.remove('alertMsg--hide');
            }, ALERT_EXIT_DURATION);
        }, ALERT_DURATION); // El mensaje dura 3 segundos antes de desaparecer
    })

}

function capitalizar(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function quitarAcentos(cadena){
	const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};

    cadena = cadena.trim().replace(/,/g, '');

	return cadena.split('').map( letra => acentos[letra] || letra).join('').toString();	
}

// Se usa para valores que solo son positivos
function formatCurrency(value,input=true,ignoreDecimal=true) {

    if(!input){
        if(ignoreDecimal){
            value = value.replace('.00', '');
        }
        value = value.replace('.', ',');
    }

    // Permitir solo números y una coma, eliminando caracteres inválidos
    value = value.replace(/[^0-9,]/g, '');

    // Quitar cualquier coma al principio si la hay
    if (value.startsWith(',')) {
        value = value.substring(1);
    }

    // Quitar comas adicionales, dejando solo la primera
    let commaIndex = value.indexOf(',');
    if (commaIndex !== -1) {
        // Mantener la primera coma y eliminar las demás
        value = value.substring(0, commaIndex + 1) + value.substring(commaIndex + 1).replace(/,/g, '');
    }

    // Quitar cualquier punto existente para evitar duplicaciones
    value = value.replace(/\./g, '');

    // Formatear la parte entera del número con puntos como separador de miles
    let parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if((parts[0][0] == 0) && (parts[0][1] != ',')){
        parts[0] = parts[0].substring(1);  
    }
    if(parts[0] == ''){
        parts[0] = 0;
    }

    // Combinar la parte entera y decimal (si existe)
    formValue = '$ ' + parts.join(',');

    return formValue;
}

// Se usa para valores que solo son positivos
function formatCurrencyToFloat(value){
    return parseFloat(value.replace('$', '').replace(/\./g, '').replace(',', '.'));
}

// Se usa para valores que pueden o no ser negativos
function formatCurrencyNegative(value,input=true,ignoreDecimal=true) {

    if(!input){
        if(ignoreDecimal){
            value = value.replace('.00', '');
        }
        value = value.replace('.', ',');
    }

    negative = false;
    // Detectar negativo al inicio y quitarlo de la cadena
    if (value.startsWith('-')) {
        negative = true;
        value = value.substring(1);
    }

    // Permitir solo números y una coma, eliminando caracteres inválidos
    value = value.replace(/[^0-9,]/g, '');

    // Quitar cualquier coma al principio si la hay
    if (value.startsWith(',')) {
        value = value.substring(1);
    }

    // Quitar comas adicionales, dejando solo la primera
    let commaIndex = value.indexOf(',');
    if (commaIndex !== -1) {
        // Mantener la primera coma y eliminar las demás
        value = value.substring(0, commaIndex + 1) + value.substring(commaIndex + 1).replace(/,/g, '');
    }

    // Quitar cualquier punto existente para evitar duplicaciones
    value = value.replace(/\./g, '');

    // Formatear la parte entera del número con puntos como separador de miles
    let parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if((parts[0][0] == 0) && (parts[0][1] != ',')){
        parts[0] = parts[0].substring(1);  
    }
    if(parts[0] == ''){
        parts[0] = 0;
    }

    // Combinar la parte entera y decimal (si existe)
    const numberFormatted = parts.join(',');
    const prefix = (negative ? '- $' : '$');
    return prefix + numberFormatted;

}

// Se usa para valores que pueden o no ser negativos
function formatCurrencyToFloatNegative(value){

    negative = false;
    // Detectar negativo al inicio y quitarlo de la cadena
    if (value.startsWith('-')) {
        negative = true;
        value = value.substring(1);
    }

    parseValue = parseFloat(value.replace('$', '').replace(/\./g, '').replace(',', '.'));

    if(negative){parseValue = (parseValue * -1)}

    return parseValue
}

function todayStr() {
  const hoy = new Date();

  return `${String(hoy.getDate()).padStart(2, '0')}/${String(hoy.getMonth() + 1).padStart(2, '0')}/${hoy.getFullYear()}`;
}
